export default {
    
    seleccionaNegocio:"Selecciona negoci...",
    filtraPorEtiqueta:"Filtra per etiqueta",

    noEncontramosResultadosPara:"No trobem resultats per ",
    mostrando:"Ensenyant",
    resultado:"resultat",
    resultados:"resultats",

    //ALMACÉN
    totalAlmacen:"Total magatzem",
    totalAlmacenDto:"Total magatzem dte.",
    existenciasTeoricas:"Existències Teoriques",
    diferencia:"Diferència",
    noContabilizado:"No contabilitzat",

    seleccioneUnaFechaDeInicioYUnaFechaDeFin:"Seleccioni una data d'inici i una data final ",

    //INFORMES
    inicio: "Inici",
    informes: "Informes",
    productos: "Productes",
    ventasPorNegocio: "Vendes per negoci",
    casas: "Cases",
    facturasSimplificadas: "Factures simplificades",
    comprasPorNegocio: "Compres per negoci",
    comprasPorCasas: "Compres per cases",
    gastosPorProveedor: "Despeses per proveïdor",
    gastosPorSubproductos: "Despeses per materies primeres",
    sage: "SAGE",
    sageplancuentas: "Plà de Comptes",
    sageclientes: "Clients",
    sageefectos: "Efectes",
    sageasientos: "Assentament comptable",

    //CASAS
    nuevaCasa: "Nova casa",
    casa: "Casa",
    negocio: "Negoci",
    desde: "Des",
    hasta: "Fins",
    consultar: "Consultar",
    infoCasas: "Aquest consum de cases ve de les despeses introduïdes en el rang de data seleccionat",
    exportarInforme: "Exportar informe",
    exportarPdf: "Exportar com PDF",
    exportarExcel: "Exportar com Excel",
    exportarExcelSinSubproductos: "Exportar com Excel amb materies primeres",

    //TABLA
    fecha: "Data",
    subproductos: "Materies primeres",
    subproducto: "Materia primera",
    unidades: "Unitats",
    partes: "Parts",
    precio: "Preu",
    total: "Total",
    infoConsumo: "Aquest consum de cases ve de les despeses introduïdes en el rang de data seleccionat",
    noHay: "No hi ha",
    gastos: "Despeses",
    rangoDeFechas: "en aquest rang de dates.",
    configuracion: "Configuració",
    datosFiscales: "Dades Fiscals",

    // DATOS FISCALES
    nombreFiscal: "Nom fiscal",

    //FORM CASA
    nombreCasa: "Nom Casa",
    cifNif: "CIF NIF",
    direccion: "Adreça",
    provincia: "Provincia",
    ciudad: "Ciutat",
    codigoPostal: "Códi Postal",
    pais: "Païs",
    telefono: "Telèfon",
    correoElectronico: "Correu Electrònic",
    baja: "Baixa",
    guardar: "Guardar",
    cancelar: "Cancelar",
    replicar: "Replicar en altres negocis",
    replicarCasa: "Replicar casa en altres negocis",
    seleccionarTodos: "Seleccionar tots",
    aceptar: "Acceptar",
    casaMin: "cases",

    //
    compras: "Compres",
    agregarCasa: "Afegir Casa",
    email: "Email",
    acciones: "Accions",
    editar: "Editar",
    enEsteNegocio: "en aquest negoci.",

    //PLACEHOLDER
    introduzcaNombre: "Introdueixi nom",
    introduzcaCifNif: "Introdueixi CIF / NIF",
    introduzcaDireccion: "Introdueixi adreça",
    introduzcaProvincia: "Introdueixi provincia",
    introduzcaCiudad: "Introdueixi ciutat",
    introduzcaCodigoPostal: "Introdueixi codi postal",
    introduzcaTelefono: "Introdueixi telèfon",
    introduzcaCorreo: "Introdueixi correu electronic",
    buscar: "Cercar...",

    //PROVEEDORES
    proveedores: "Proveïdors",
    agregarProveedor: "Afegir Proveïdor",
    proveedor: "Proveïdor",
    categoria: "Categoría",
    proveedoresMin: "proveïdors",

    //FORM
    nombreProveedor: "Nom Proveïdor",
    acreedor: "Creditor",
    infoAcreedor: "(Si un proveïdor es creditor no apareixerà a Numier TPV)",
    replicarProveedor: "Replicar proveïdor en altres negocis",
    category: "Categoría",
    replicarCategory: "Replicar etiqueta en altres negocis",

    //ETIQUETAS
    etiquetas: "Etiquetes",
    etiqueta: "Etiqueta",
    sinEtiqueta: "Sense etiqueta",
    nuevaEtiqueta: "Nova etiqueta",
    agregarEtiqueta: "Afegir etiqueta",
    tipo: "Tipus",
    etiquetaPadre: "Etiqueta Pare",
    tipoPadre: "Tipus Pare",

    //FORM
    nombreEtiqueta: "Nom Etiqueta",

    //SUBPRODUCTOS
    agregarSubproducto: "Afegir Matèria primera",
    precioCompra: "Preu de compra",
    escandallo: "Escandall",
    subproductosCreados: "Matèria Primera Creada",
    nuevaCategoria: "Nova categoría",
    materiaPrima: "Matèria primera",
    materiasPrimas: "Matèrias primeres",

    //FORM
    nuevoProveedor: "Nou Proveïdor",
    nombreSubproducto: "Nom Matèria primera",
    codigoBarra: "Codi de barres",
    descripcion: "Descripció",
    tipoIva: "Tipus I.V.A.",
    cuotaIVA: "Quota IVA",
    ivaIncluido: "(IVA inclòs)",
    descuentoCompra: "Descompte compra",
    porcentaje: "(% Percentatge)",
    guardarEnAlmacen: "Guardar en magatzem",
    stockMinimo: "Stock mínim",
    stockOptimo: "Stock óptim",
    gastosPorProveedoresUnidos: "Despeses per proveïdors junts",

    //INFORME SUBPRODUCTO
    referencia: "Referència",
    uds: "Unts",
    iva: "IVA",
    importe: "Import",
    dto: "Dte",
    ttal: "Total",

    //PRODUCTOS
    producto: "Producte",
    precioDeCoste: "Preu de cost",
    tarifa1: "Tarifa 1",
    tarifa2: "Tarifa 2",
    tarifa3: "Tarifa 3",
    tarifa4: "Tarifa 4",
    agregarProductos: "Afegir producte",
    noHayProductosEnEsteNegocio: "No hi han productes en aquest negoci",
    sinCategoria: "Sense Categoría",

    //FORM
    nombreProducto: "Nom producte",
    codigoDeBarra: "Codi de barres",
    colorBoton: "Color del botó:",
    descuento: "Descompte",
    precioCoste: "Preu de cost",
    opcionesAlSeleccionarElArticulo: "Opcions al seleccionar el producte",
    numeroDeOpcionales: "Número de materies primeres opcionals",
    impresoraComandasTPV: "Impressora Comandes TPV",
    impresoraComandasPDA: "Impressora Comandes PDA",
    copiaImpresoraComandasTPV: "Còpia Impressora Comandes TPV",
    copiaImpresoraComandasPDA: "Còpia Impressora Comandes PDA",
    impresionPlano1: "Impressora Pla 1",
    impresionPlano2: "Impressora Pla 2",
    impresionPlano3: "Impressora Pla 3",
    impresionKDSTPV: "Enviar comanda desde TPV",
    impresionKDSPDA: "Enviar comanda desde PDA",
    pedirPrecio: "Demanar preu",
    pedirPeso: "Demanar pes",
    pedirImporte: "Demanar import",
    promocionable: "Promocionable",
    mostrarPC: "Ensenyar a PC",
    mostrarPDA: "Ensenyar a PDA",
    noImprimir: "No Imprimir",
    numeroPlato: "Número de plat per defecte",
    seleccionIngredientes: "Activar selecció d'ingredients",
    introduzcaDescripcion: "Introdueixi descripció",
    introduzcaCodigoDeBarras: "Introdueixi codi de barres",
    introduzcaPrecioCoste: "Introdueixi preu de cost",
    opcion1: "Opció 1",
    opcion2: "Opció 2",
    opcion3: "Opció 3",
    opcion4: "Opció 4",
    opcion5: "Opció 5",
    numOpcionales: "Número de materies primeres opcionals",

    //OPERARARIOS
    operarios: "Operaris",
    agregarOperario: "Afegir operari",
    apellido: "Cognom",
    nombreOperarios: "Nom Operaris",
    pass: "Contrasenya",
    salario: "Sou",
    passTurn: "Contrasenya de torn",
    hombre: "Home",
    mujer: "Dona",
    replicarProducto: "Replicar producte en altres negocis",
    introduzcaEscandallo: "Introdueixi escandall",
    introduzcaStockMinimo: "Introdueixi stock mínim",
    introduzcaStockOptimo: "Introdueixi stock optim",
    introduzcaPrecioCompra: "Introdueixi preu compra",
    introduzcaApellido: "Introdueixi cognom",
    introduzcaPass: "Introdueixi Contrasenya",
    introduzcaEmail: "Introdueixi email",
    introduzcaSalario: "Introdueixi salari",
    introduzcapassTurn: "Introdueixi contrasenya de torn",
    replicarOperario: "Replicar operario en altre negoci",
    TPV: "TPV",
    precioMed: "Preu Mitjà",
    porUnidad: "Per unitats",
    porImporte: "Per import",
    contrasenya: "Contrasenya PDA",
    repartidor: "Repartidor",
    noMostrarEnVentas: "No ensenyar en vendes",
    noHayOperariosEnEsteNegocio: "No hi han operaris en aquest negoci",
    VerDetalles: "Veure Detalls",
    accesoDenegado: "Accés Denegat",

    //CLIENTES
    cliente: "Client",
    clientes: "Clients",
    companyia: "Campanya",
    agregarCliente: "Afegir client",
    nombreCliente: "Nom client",
    saldo: "Saldo",
    infoCliente: "En el cas d'utilitzar targetes de saldo",
    tarifa: "Tarifa",
    descuentoImporte: "Descompte import",
    noHayClientesEnEsteNegocio: "No hi han clients en aquest negoci",

    //IMPRESION
    impresionDeComandas: "Impressió de comandes",
    copiaDeImpresionDeComandas: "Copia d'impressió de comandes",
    impresionPorPlana: "Impressión per plà",
    monitorDeCocina: "Monitor de cuina",

    //INFORMES
    ventas: "Vendes",
    tarjetas: "Targetes",
    cheque: "Taló",
    cambio: "Canvi",
    recuento: "Recompte",
    descuadre: "Descuadre",
    siguienteDia: "Següent dia",
    incidencias: "Incidències",
    recaudado: "Recaptat",
    noHayVentasEnEsteRangoDeFechas: "No hi han vendes en aquest rang de dates",
    tickets: "Tickets",
    factura: "Factura",
    noHayFormasDePagoEnEsteRangoDeFecha: "No hi han formes de pagament en aquest rang de dates",
    desglose: "Desglossament",
    sinBase: "Sense Base",
    base: "Base",
    impuesto: "Impost",
    facturasEmitidas: "Factures nominatives",
    mesa: "Taula",
    cifnif: "CIF/NIF",
    cobro: "Cobro",
    noHayFacturasEmitidasEnEsteRangoDeFecha: "No hi han factures emeses en aquest rang de dates",
    estadisticasAgencias: "Estadístiques Agencies",
    agencia: "Agencia",
    comentario: "Comen.",
    noHayEstadisticasDeAgenciaEnEsteRangoDeFechas: "No hi han estadístiques d'agencies en aquest rang de dates",
    desglosesImpuestos: "Impostos per tancament de caixa",
    desglosesImpuestosAgencia: "Impostos per agència",
    noHayFormasDePagoEnEsteRangoDeFechas: "No hi han formes de pagament en aquest rang de dates",
    cuentasAparcadas: "Comptes a crèdit",
    operacion: "Operació",
    operario: "Operari", //new
    noExisteDesgloseImpuestos: "No hi ha desglossament d'impostos.", //new
    noHayCuentasAparcadasEnEsteRangoDeFechas: "No hi han comptes a crèdit en aquest rang de dates",
    noHayCuentasAnuladasEnEsteRangoDeFechas: "No hi han comptes anulades en aquest rang de dates",
    cierreCaja: "Tancament de caixa",
    fechaCierre: "Data tancament",
    venta: "Venda",
    totalRecaudado: "Total recaptat",
    noHayCierresDeCajaEnEsteRangoDeFecha: "No hi han tancaments de caixa en aquest rang de dates",
    cierreCajaZ: "Tancament de caixa Z",

    //MODAL
    n: "Nº.",
    apertura: "Obertura",
    cierre: "Tancament",
    totalVenta: "Total Venda",
    efectivo: "Efectiu",
    tarjetaCheques: "Targ+Talons",
    totalTeorico: "Total teóric",
    totalEnArqueo: "Total en arqueig",
    cambioSig: "Canvi seg",
    volver: "Tornar",
    confirmacionImportacionHeader: "Confirmació d'importació",
    confirmacionImportacionText: "Estàs segur de que vols importar?",
    cancelar: "Cancelar",
    confirmar: "Confirmar",
    registros: "registres",
    headerError: "ERROR",
    bodyError: "Si us plau, insereixi un arxiu amb menys de 10.000 registres",
    en: "En ",

    //OPERARIOS
    ventasPorOperarios: "Vendes per operaris",
    invitaciones: "Invitacions",
    horas: "Hores",
    sueldo: "Sou",
    categorias: "Categoríes",

    //CLIENTES
    ventasPorClientes: "Vendes per client",
    companya: "Empresa",
    consumiciones: "Consumicions",
    media: "Mitjana",
    mediaSesion: "Mitja sesió",

    //AGENCIAS
    noHayAgenciasEnEsteMomento: "No hi han agències en aquest moment",
    agencias: "Agències",
    nombreAgencia: "Nom agència",
    comision: "Comisió",
    replicarAgencias: "Replicar agència",
    agregarAgencias: "Afegir agència",

    //MODIFICADORES
    nombreModificador: "Nom modificador",
    grupos: "Grups",
    variacion: "Variació",
    resta: "Resta",
    suma: "Suma",
    modificador: "Modificador",
    modificadores: "Modificadors",
    agregarModificador: "Afegir modificador",
    grupo: "Grup",
    noHayModificadoresEnEsteNegocio: "No hi han modificadors en aquest negoci",
    almacen: "Magatzem",
    todos: "Tots",
    precioCompraConIva: "Preu compra AMB IVA",
    precioCompraSinIva: "Preu compra SENSE IVA",
    precioDescuentoSinIva: "Preu amb descompte SENSE IVA",
    codigoIdentificacion: "Códi identificació",
    replicarModificador: "Replicar modificador",

    // SOPORTE ONLINE
    soporteOnline: "Suport Online",
    soporteOnlineDetails: "Suport Online - Detalls",
    abierto: "Obert",
    esperandoRespuesta: "Esperant Resposta",
    respondido: "Contestat",
    cerrado: "Tancat",
    tecnico: "Técnic",
    comercial: "Comercial",
    facturacion: "Facturació",
    noTicketsEnNegocio: "No hi han tickets en aquest negoci",
    responderTicket: "Respondre ticket",
    mensaje: "Missatge",
    cerrar: "Tancar",
    enviarTicket: "Enviar Ticket",
    nuevoTicket: "Nou ticket",
    asunto: "Assumpte",
    estado: "Estat",
    departamento: "Departament",
    visitas: "Visites",
    verTicket: "Veure ticket",
    tarjeta: "Targeta",

    //FORMAS DE PAGO
    nueva: "Nova",
    replicarFormaDePago: "Replicar Forma de pagament",
    nombreFormaPago: "Nom forma de pagament",
    formaDePago: "Forma de pagament",
    formasDePago: "Formes de pagament",
    agregarFormaDePago: "Afegir forma de pagament",
    noHayFormasDePagoEnEsteNegocio: "No hi han formes de pagament en aquest negoci",
    nuevo: "Nou",

    //EDICIÓN MASIVA
    transferirProductosDeCategoria: "Transferir productes de categoría",
    tranferir: "Transferir",
    impresionDeProductosDeCategorias: "Impressió de productes de categories",
    impresoraComanda: "Impressora comanda",
    impresoraComandaTpv: "Impressora comanda TPV",
    impresoraComandaPda: "Impressora comanda PDA",
    copiaImpresionDeComanda: "Copia impressió de comandes",
    copiaImpresoraComandasTpv: "Copia impressora comandes TPV",
    copiaImpresoraComandasPda: "Copia impressora comandes PDA",
    impresionPorPlano: "Impressión per plà",
    enviarComandaDesdeTpv: "Enviar comanda desde TPV",
    enviarComandaDesdePda: "Enviar comanda desde PDA",
    respetarOtrasImpresiones: "Respectar altres impressions?",
    cambioDePrecioProductos: "Canvi de preu de productes",
    opcion: "Opció",
    tipoDeTarifa: "Tipus de tarifa",
    cambiarPrecio: "Canviar preu",
    ajustes: "Ajustaments",
    cambiarImpresionDeGrupo: "Canviar impressió de grup",
    tranferirProductosDeUnaCategoriaAOtra: "Transferir productes d'una categoría a una altre",
    cambiarPreciosAProductos: "Canviar preus a productes",

    //WIDGETS
    consumoPorHoras: "Vendes per hores",
    productosMasVendidos: "Productes més venuts",
    ultimosTickets: "Ultims tickets",
    verTodos: "Veure Tots",
    arqueoDeCaja: "Arqueig de Caixa",
    cobrado: "Cobrat",

    cajaCerrada: "Caixa Tancada",
    licenciaCaducada: "Licència Caducada",
    cajonInteligente: "Calaix inteligent",
    moneda: "Moneda",
    nivelReciclador: "Nivell Recicl.",
    totalReciclador: "Total Recicl.",
    nivelCasete: "Nivell Casset",
    totalCasete: "Total Casset",
    totalMonedas: "Total monedes",
    totalBilletes: "Total billets",
    totalEnDirectoPorNegocio: "Vendes en directe per negocis",
    enCuenta: "En compta",
    cajaOnline: "Caixes Online",
    planoDeMesas: "Plà de taules",
    planoDeTaquillas: "Plà de taquilles",
    nombrePlano: "Nom plà",
    mesas: "Taules",
    taquillas: "Taquilles",
    ocupacion: "Ocupació",
    enPlano: "En plà",
    desgloseTicket: "Desglossament de ticket",
    precioMedio: "Preu mitjà",
    apuntado: "Apuntat",
    anulado: "Anulat",
    aparcado: "A crédit",
    indicencias: "Incidències",
    filtrarOperario: "Filtrar operario",
    situacionActualDeLosNivelesDelCajonInteligente: "Situació actual dels nivells del calaix inteligent",
    verDetallesDeNiveles: "Veure detalls de nivells",
    noHayCajonInteligenteParaMostrar: "No hi ha calaix inteligent per ensenyar",
    consulteConSuDistribuidor: "Consulti amb el seu distribuidor",
    comparativaVentasAnteriores: "Comparativa vendes anteriors",
    graficaDeConsumoRespectoAHistoricoDeSesiones: "Gràfica de consum respecte a l'históric de sesions",
    graficaDeConsumoAgrupadaPorTramosHorarios: "Gràfica de consumo agrupada per trams",
    situacionActualDeOcupacionDeMesas: "Situació actual d'ocupació de taules",
    situacionActualDeOcupacionDeTaquillas: "Situació actual d'ocupació de taquilles",
    verPlanoCompleto: "Veure plà complert",
    rankingDeLaSesionActual: "Ranking de la sesió actual",
    ultimosMovimientosDeLaCajaPorOperario: "Últims movimients de la caixa per operari",
    estadoActualDeLaCaja: "Estat actual de la caixa",
    turnosDeOperarios: "Torns d'operaris",
    relacionDeHorasTrabajadasYVentasRealizadasPorOperario: "Relació d'hores treballades i vendes realitzades per operari",
    horarioInicio: "Hora d'inici",
    horaFin: "Hora fi",
    horasTrabajadas: "Hores traballades",
    noHayTurnosDeOperarioParaMostrar: "No ni han torns d'operaris per ensenyar",
    propuestaDePedido: "Proposta de comanda",
    pedidoAProveedor: "Comanda a proveïdor",
    atencionHayMovimientosDeAlmacenQueNoSeHanDescargadoEnElNegocio: "Atenció, hi han moviments de magatzem que no s'han descarregat en el negoci",
    seleccionarNegocio: "Seleccionar negoci",
    seleccionarProveedor: "Seleccionar proveïdor",
    generarPedidoEnBlanco: "Generar comanda en blanc",
    generarPedido: "Generar comanda",
    propuestaDePedidoA: "Proposta de comanda a ",
    buscarMateriaPrimaEnElMismoProveedor: "Cercar matèria primera en el mateix proveïdor",
    precioIVAIncluido: "Preus IVA inclos",
    ref: "Ref",
    nombre: "Nom",
    existencias: "Existències",
    pedido: "Comanda",
    precioArticuloUnidad: "Preu artícle / unt",
    precioPedido: "Preu Comanda",
    sinIVA: "Sense IVA",
    porcentajeIVA: "% IVA",
    precioIVA: "Preu IVA",
    porcentajeDto: "% Dto",
    totalIVA: "Total IVA",
    observaciones: "Observacions",
    noHaySubproductosEnEsteNegocioParaRealizarElPedido: "No hi han subproductes en aquest negoci per la comanda",
    recuerdeQueParaQueAparezcanLosSubproductosDebenDeEstarAsociadosAUnProveedorYConfiguradosElStockMinimoYStockOptimo: "Recordi que per que es vegin els subproductes han d'estar associats a un proveïdor i configurats  stock mínim i stock  óptim",
    guardarPedido: "Guardar comanda",
    totalIVAInc: "Total IVA Inc.",
    pedidosAProveedor: "Comada a proveïdor",
    fechaInicio: "Data d'inici",
    fechaFin: "Data final",
    pedidosConvertidos: "Comandes convertides",
    nuevoPedido: "Nova comanda",
    enviarPedidos: "Enviar preus",
    convertido: "Convertit",
    convertirEnGasto: "Convertir en despessa",
    modificar: "Modificar",
    eliminar: "Eliminar",
    descargarComoPDF: "Descarregar com PDF",
    descargarComoPDFSinPrecios: "Descarregar com PDF sense preus",
    descargarComoExcel: "Descarregar com Excel",
    descargarComoExcelSinPrecios: "Descarregar com excel sense preus",
    enviarPorCorreo: "Enviar per correu",
    eliminarListaCorreo: "Eliminar llista correu",
    anyadirListaCorreo: "Afegir llista correu",
    noHayPedidosAEsteProveedorEnEsteRangoDeFecha: "No hi han comandes a aquest proveïdor en aquest rang de dates",
    enviarPedido: "Enviar comanda",
    enviarPedidoA: "Enviar comanda a",
    formato: "Format",
    PDF: "PDF",
    excel: "Excel",
    conPrecios: "Amb preus",
    sinPrecios: "Sense preus",
    convertirPedido: "Convertir comanda",
    tipoDeDocumento: "Tipus de document",
    albaran: "Albarà",
    generarEntradaEnAlmacenAlVerificar: "Generar entrada en magatzem al verificar",
    gastosDeCasas: "Despeses de cases",
    gastosPorCasa: "Despeses per casa",
    noHayGastosPorCasasEnEsteRangoDeFechas: "No hi han despeses per cases en aquest rang de dates",
    ventasDeCategorias: "Vendes de categoríes",
    ventasCategoriaDe: "Venda categoría de ",
    volverAGeneral: "Tornar a general",
    ventasDeProductos: "Vendes de productes",
    filtrarPorTPV: "Filtrar per TPV",
    filtrarTPV: "Filtrar TPV",
    turnosDe: "Torns de ",
    enActivo: "En actiu",
    ventasDeProductosDe: "Vendes de productes de ",
    ventasOperarios: "Vendes operaris",
    costesDeProductos: "Cost de productes",
    totalImportesVentas: "Total Imports Vendes",
    totalCoste: "Total cost",
    costes: "Cost",
    costeUd: "Cost Ud",
    coste: "Cost",
    porcentajeCosto: "% Cost",
    varCostoMed: "Var. Cost Mitja",
    listaDeInvitaciones: "Llista d'invitacions",
    valor: "Valor",
    volverALaLista: "Tornar a la llista",
    ventasDeProductosGlobal: "Vendes de productes global",
    porUnidades: "Per unitats",
    gastosPorEtiquetas: "Despeses per etiquetes",
    desgloseDeGastos: "Desglossament de despeses",
    referencias: "Referències",
    concepto: "Concepte",
    gastosDeProveedores: "Despeses de proveïdors",
    sinProveedor: "Sense Proveïdor",
    sinCasas: "Sense cases",
    cierreDeCaja: "Tancament de caixa",
    primerTicket: "Primer Ticket",
    ultimoTicket: "Últim ticket",
    cheques: "Talons",
    cambioSigDia: "Canvio seg. día",
    ventasPorAgencias: "Vendes per agències",
    ventasPorFormasDePago: "Vendes per forma de pagament",
    exportarComoHTML: "Exportar com HTML",
    pendiente: "Pendent",
    gasto: "Despesa",
    desgloseDeImpuestos: "Desglosament d'impostos",
    desgloseDelTicket: "Desglossament del ticket",
    cuentasAnuladas: "Comptes anulades",
    buscarPorHoras: "Cercar per hores",
    graficas: "Gràfiques",
    mostrarVentasAcumuladasPorDia:"Mostra vendes acumulades per dia", 
    seleccionaUnTpv:"Has de seleccionar un TPV per veure'n els detalls",
    deshabilitarCheckboxVentasAcumuladasPorDia:"Deshabilita el checkbox 'Mostrar vendes acumulades per dia' per veure'n els detalls.",
    dias: "Dies",
    semanas: "Semanes",
    meses: "Mesos",
    ventasPorComensales: "Vendes per comensals",
    numeroDeComensales: "Nombre de comensals",
    precioMedioPorComensal: "Preu mitja per comensal",
    ventasPorRangosHorarios: "Vendes per rangs horaris",
    ops: "Ops",
    comensales: "Comensals",
    detalleDeOperaciones: "Detall d'operacions",
    operaciones: "Operacions",
    operacionMedia: "Operació mitja",
    detalleDeComensales: "Detall de comensals",
    comensalMedio: "Comensal mitja",
    noHayVentasEnLosRangosDeFechasDefinidos: "No hi han vendes en els rangs de dates definides",
    transferencia: "Transferència",
    domiciliacion: "Domiciliació",
    fechaGasto: "Data despesa",
    generarEntradaDeAlmacenAlVerificar: "Generar entrada de magatzem al verificar",
    listaDeMateriaPrima: "Llista de materia primera",
    preciosIVAIncluido: "Preus IVA inclos",
    precioSinIVA: "Preu sense IVA",
    precioIVAInc: "Preu IVA inc",
    IVA: "IVA",
    totalBase: "Total base",
    totalDocumento: "Total document",
    seleccioneUnaCasa: "Seleccioni una casa",
    anyadirNuevoSubproducto: "Afegir nou subproducte",
    gestionDeGastos: "Gestio de despeses",
    deCaja: "De caixa",
    fueraDeCaja: "Fora de caixa",
    contabilizado: "Contabilitzat",
    si: "Si",
    no: "No",
    grafica: "Gràfica",
    lista: "Llista",
    avanzado: "Avançat",
    noHayVentasDeProductosEnEsteRangoDeFechas: " No hi han vendes de productes en aquest rang de dates",
    historicoDeProductos: "Históric de productes",
    volverA: "Tornar a",
    general: "general",
    historialAlmacen: "Historial magatzem",
    listadoDeExistencia: "Llistat d'existencia",
    listadoDeAlmacen: "Llistat de magatzem",
    listadoHastaStockOptimo: "Llistat fins stock óptim",
    listadoExistenciaBajoMinimo: "Llistat d'existencia sota mínim",
    exportarValoracion: "Exportar valoració",
    importeDto: "Import Dte",
    detalleDelSubproducto: "Detall del subproducte",
    nombreNegocio: "Nom negoci",
    noHaySubproductosConElMismoNombreEnTusOtrosNegocios: "No hi han subproductes amb el mateix nom en els teus altres negocis",
    detalleAlmacen: "Detall magatzem",
    entrada: "Entrada",
    inventario: "Inventari",
    salida: "Sortida",
    valorDto: "Valor Dte.",
    noHayDatosEnEsteMovimientoDeAlmacen: "No hi han dades en aquest moviment de magatzem",
    historial: "Historial",
    noHayMovimientoEnEstaMateriaPrima: "No hi han moviments en aquesta materia primera",
    dia: "Dia",
    historialDeAlmacen: "Historial de magatzem",
    inventarios: "Inventaris",
    entradas: "Entrades",
    salidas: "Sortides",
    completado: "Completat",
    verificado: "Verificat",
    descargado: "Descarregat",
    diaActual: "Dia actual",
    movimientos: "Moviments",
    enEsteRangoDeFechas: "en aquest rang de dates",
    rangosHorarios: "Rangs horaris",
    nuevoRangoHorario: "Nou rang horari",
    verUnInformeDeRangosHorarios: "Veure un informe de rangs horaris",
    noHayRangosHorariosEnEsteNegocio: "No hi han rangs horaris en aquest negocio",
    nombreRangosHorarios: "Nom rangs horaris",
    vistaMosaico: "Vista mosaic",
    vistaLista: "Vista llista",
    ordenarProductos: "Ordenar productes",
    BAJA: "BAIXA",
    frontalDeVenta: "Frontal de venda",
    agregarGasto: "Afegir despesa",
    entrAlmac: "Entr. Magat.",
    contab: "Contab",
    tranferencia: "Transferència",
    verificar: "Verificar",
    entradaAlmacen: "Entrada de magatzem",
    preciosIVAInluido: "Preus IVA Inclòs",
    estaEntradaNoContieneNingunSubproducto: "Aquesta entrada no conte cap subproducte",
    cajasOnline: "Caixes online",
    minimo: "Mínim",
    optimo: "Óptim",
    posicionGlobal: "Posició global",
    empresa: "Empresa",
    ventasSinIVA: "Vendes sense IVA",
    neto: "Net",
    fechaDeCumpleanyos: "Data d'aniversari",
    recargoEquivalencia: "Recarec d'equivalencia",
    anyadirMateriaPrima: "Afegir Materia primera",
    partesT1: "Parts T1",
    partesT2: "Parts T2",
    partesT3: "Parts T3",
    partesT4: "Parts T4",
    costeDto: "Cost Dto",
    agregarMateriasPrimas: "Afegir Materies primeres",
    frontalDeVentas: "Frontal de vendes",
    unidadesEnOtroNegocios: "Unitats en altres negocis",
    historialMateriaPrima: "Historial materia primera",
    verDetalles: "Veure detalls",
    borrarRangoHorario: "Esborrar rang horari",
    detallesDeLaEntradaEnAlmacen: "Detalls de l'entrada en magatzem",
    desgloseHorasTrabajadas: "Desglossament hores treballades",
    verProductosVendidos: "Veure productes venuts",
    verTicketsDelProducto: "Veure tickets del producte",
    verTicketsDeEsasInvitaciones: "Veure tickets d'invitacions",
    verTicketsDeEsaAgencia: "Veure tickets d'aquesta agència",
    gastosPorMateriasPrimas: "Despeses per materies primeres",
    alDarUnProductoDeBajaDesapareceEnElTPVParaSuVentaPeroSigueApareciendoEnLosInformesDeVenta: "Quan donem de baixa un producte desapareix en el TPV per la seva venda, pero surt en els informes de venda",
    cuandoUnProductoEsDeTipoDescuentoSuPrecioSeDescuentaDelTotalDeLaCuenta: "Quan un producte és del tipùs descompte el seu preu es descompta del total del compte",
    alActivarEstaOpcionApareceLosIngredientesDelProductoParaSeleccionarlo: "Quan activem aquesta opció apareixen els ingredients del producte per seleccionar-los",
    alActivarEstaOpcionPuedeSeleccionarElPrecioDelProductoAlMarcarlo: "Quan activem aquesta opció pot seleccionar el preu del producte al marcar-lo",
    alActivarEstaOpcionPuedeSeleccionarElPesoDelProductoAlMarcarlo: "Quan activem aquesta opció pot seleccionar el pes del producte al marcar-lo",
    alActivarEstaOpcionPuedeSeleccionarElImporteDelProductoAlMarcarlo: "Quan activem aquesta opció pot seleccionar l'import del producte al marcar-lo",
    alActivarEstaOpcionElProductoNoApareceraEnNumierTPV: "Quan activem aquesta opció el producte no sortirà a Numier TPV",
    alActivarEstaOpcionElProductoNoApareceraEnLaPda: "Quan activem aquesta opció el producte no sortirà a Numier PDA",
    alActivarEstaOpcionElProductoNoSeImprimiraEnElPendienteDeCobroNiEnLaFacturaSimplificada: "Quan activem aquesta opció el producte no s'imprimirà en el pendent de cobrament ni en la factura simplificada",
    guardarMateriaPrima: "Guardar matèria primera",
    copiarMateriaPrima: "Copiar matèria primera",
    seleccioneQueTipoDeMateriasPrimasQuiereCopiar: "Seleccioni quin tipus de materies primeres vol copiar",
    seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas: "Seleccioni a quines categoríes vol copiar les materias primeres",
    copiaMateriaPrima: "Copia materia primera",
    notas: "Notes",
    pedidos: "Comandes",
    atencionLaMediaSinContarLosDiasConVentas: "Atenció: La mitja sense contar els díes amb vendes a 0€ es de: ",
    verDesgloseDeImpuestos: "Veure desglossament d'impostos",
    verDetallesDetTicket: "Veure detalls del ticket",
    facturasNominativas: "Factures nominatives",
    verDetallesDeGasto: "Veure detalls de despeses",
    desgloseDeGastosPorEtiquetasHijas: "Desglossament de despeses per etiquetes filles",
    procedencia: "Procedència",
    suLicenciaDeNumierOnlineEstaAPuntoDeCaducar: "La seva llicència de Numier Online está apunt de caducar",
    cajasOnlineTickets: "Caixes Online Tickets",
    cajasOnlineDetalles: "Caixes Online Detalls",
    cajasOnlinePlano: "Caixes Online Plà",
    cajasOnlineProductos: "Caixes Online Productes",
    transferir: "Transferir",
    herramientas: "Eines",
    ver: "Veure",
    detallesDeLaentradaEnAlmacen: "Detalls de l'entrada en el magatzem",
    ups:"Ups",
    laFechaDeInicioNoPuedeSerPosteriorALaDeFin:"La data d'inici no pot ser posterior a la final",
    exportarContabilidad: "Exportar comptabilitat",
    exportar: "Exporta",
    //NUEVO==========================   
    seleccioneUnProveedor:"Seleccioni un proveïdor",
    detallesDelPedido:"Detalls de la comanda",
    correoEnviadoCorrectamente:"Correu enviat correctament",
    atencion:"Atenció",
    debeIntroducirUnEmailParaEnviarElPedido:"Ha d'introduïr un email per enviar la comanda",
    detalles:"Detalls",
    gastoVerificadoCorrectamente:"Despesa verificada correctament",
    estasSeguroDeEliminarElPedido:"Estàs segur d'eliminar la comanda?",
    estaOperacionNoSePuedeDeshacer:"Aquesta operació no es pot desfer",
    siEliminarPedido:"Sí, eliminar la comanda",
    pedidoEliminadoCorrectamente:"Comanda eliminada correctament",
    laReferenciaEsObligatoria:"La referència es obligatoria",
    seleccioneLosNegociosParaHacerelPedido:"Seleccioni els negocis per fer la comanda",
    noHayProveedoresEnEsteNegocio:"no hi han proveïdors en aquest negoci",
    cuentasRectificadas:"Comptes rectificades", 
    noHayCuentasRectificadasEnEsteRangoDeFechas: "No ni han comptes rectificades en aquest rang de dates",
    pedidosProveedor: "Comandes proveïdor",
    gestionDePersonal: "Gestió de personal",
    configuracionCarta: "Configuració carta",
    importacionExcels:"Importació Excels",
    carta: "Carta digital",
    camaras: "Càmeres",
    perfil: "Perfil",
    cerrarSesion: "Tancar sesió",
    desarrolladoPorNexodoDigitalSL: "Desenvolupat per Nexodo Digital S.L.",
    totalValores: "Total Valors",
    totalValoresDto: "Total Valors Dte.",
    totalValoresRecuento: "Total Valors de Recompte",
    ultimoInventario: "Últim inventari",
    filtrarEntreInventarios: "Filtrar entre inventaris",
    ultInventario: "Ult. inventari",
    primerInventario: "Primer inventari",
    marcaDosInventariosParaVerLosDetallesEntreEllos: "Marca dos inventaris per veure els detalls entre ells",
    salir: "Sortir",
    anadirMovimientoAlmacen: "Afegir movimient magatzem",
    nuevoInventario: "Nou Inventari",
    tienesUnInventarioSinTerminarElDia: "Tens un inventari sense acabar el dia",
    pulseElBotonRealizarInventarioPara: "Premi el botó 'Fer inventari' per",
    volverARealizarlo: "tornar a realitzar-lo",
    siDeseas: "Si desitges",
    comenzarElInventarioDeNuevo: "començar l'inventari un altre cop",
    comaMarqueLaCasillaEliminarDatosDeInventarioActual: ", marqui la casella 'Eliminar dades de l'inventari actual'",
    eliminarDatosDelInventarioActual: "Eliminar dades de l'inventari actual",
    realizarInventario: "Fer inventari",
    accesoDenegado: "Accés denegat",
    soloPuedeComprobar2InventariosAlMismoTiempo: "Sols pot comprobar 2 inventaris al mateix temps",
    cargando: "Carregant...",
    configuracionAlmacen: "Configuració magatzem",
    actualizada: "actualitzada",
    correctamente: "correctament",
    noSeAdmitenCamposEnBlanco: "No s'atmeten camps en blanc",
    todas: "Totes",
    categoriaClientes: "Categoría clients",
    seleccionaCompania: "Selecciona companyia",
    agregarCategoriaDeClientes: "Afegir categoría de clients",
    categoriaPadre: "Categoría Pare",
    elCampoNombreFiscalEsObligatorio: "El camp nom fiscal es obligatori",
    elCampoCifNifEsObligatorio: "El camp Cif Nif és obligatori",
    datosActualizadosCorrectamente: "Dades actualizades correctament",
    elCampoNombreEsRequerido: "El camp nom és requerit",
    creada: "creada",
    rangoHorario: "Rang horari ",
    soloPuedeCrearUnMaximoDeXRangosHorarios: "Sols pot crear un màxim de 8 rangs horaris",
    deAcuerdo: "D'acord",
    rangoHorario: "Rang horari ",
    eliminado: "eliminat",
    deseaEliminarEsteRangoHorario: "Vol eliminar aquest rang horari?",
    siBorrarRangoHorario: "Sí, esborrar rang horari",
    ordenarProductosAlfabeticamente: "Ordenar productes alfabèticament",
    ordenarMateriasPrimasAlfabeticamente: "Ordenar materies primeres alfabèticament",
    asignarImpresorasSeleccionadasEnBlanco: "Asignar impressores seleccionades en blanc",
    aplicarCambios: "Aplicar canvis",
    ordenarAlfabeticamenteProductos: "Ordenar alfabèticament productes",
    ordenar: "Ordenar",
    ordenarAlfabeticamenteSubproductos: "Ordenar alfabèticamente subproductos",
    seleccioneElTipo: "Seleccioni el tipus",
    impresionDeProductosEfectuadaCorrectamente: "Impressió de productes efectuada correctamente",
    tienesQueSeleccionarUnaCategoria: "Tens que seleccionar una categoría",
    ningunaSeleccionada: "Cap seleccionada",
    transferenciaDeProductosEfectuadaCorrectamente: 'Transferència de productes efectuada correctament',
    relleneLosCamposObligatorios: "Ompli els camps obligatoris",
    vistaFrontalTpv: "Vista frontal TPV",
    editarPrecios: "Editar preus",
    cancelarEdicion: "Cancelar edició",
    guardarOrden: "Guardar ordre",
    bajaConBrackets: "[BAIXA]",
    seleccionaUnaCategoria:"Selecciona una categoría...",
    cambiarImpresorasAProductos: "Canviar impressores a productes",
    igualar: "Igualar",
    sumar: "Sumar",
    restar: "Restar",
    multiplicar: "Multiplicar",
    todasLasTarifas: "Totes les tarifes",
    productosEditadosCorrectamente: "Productes editats correctament",
    ordenActualizadoCorrectamente: 'Ordre actualitzat correctament',
    componentesDeVenta: "Components de venda",
    delNegocioAClientes: "del negoci a clients",
    clasificacionDe: "Clasificació de",
    productosPorFamilia: "productes per familia",
    elementosQue: "Elements que",
    varianALosProductos: "varíen als productes",
    paraLaComanda: "per la comanda",
    componentesComprados: "Components comprats",
    aProveedoresQueComponenProductos: "a proveïdors que composen productes",
    empresas: "Empreses",
    proveedorasDeMateriasPrimasYServicios: "proveïdors de materies primeres i/o serveis",
    alNegocio: "al negoci",
    fabricantesDeMateriasPrimas: "fabricants de materies primeres",
    aProveedores: "a proveïdors",
    categoriasQueClasifican: "Categoríes que clasifiquen",
    materiasPrimasYProveedores: "materies primeres i proveïdors",
    personalCon: "Personal amb",
    acceso: "acces",
    alSistema: "al sistema",
    baseDeDatosDe: "Base de dades de",
    consumidores: "consumidors",
    enElNegocio: "en el negoci",
    clasificacionDeLa: "Clasificació de la",
    deLasVentas: "de les vendes",
    metodosDeCobro: "Mètodes de cobrament",
    enElFrontalDeVenta: "en el frontal de venda",
    intervaloDeHorasParaConsultarVentas: "Interval d'hores per consultar vendes",
    configurarAlmacén: "Configurar magatzem",
    relacionDeMateriasPrimasParaLaConfiguracionDelAlmacen: "Relació de matèries primeres per la configuració del magatzem",
    herramientasGenerales: "Eines generals",
    edicionMasiva: "Edició massiva",
    categoriasCarta: "Categories carta",
    categoriaCarta: "categoria carta",
    orden: "Ordre",
    editada: "editada",
    anadirCategoria: "Afegir categoria",
    esteNegocioNoTieneAccesoAEsteModulo: "Aquest negoci no te accés a aquest módul",
    paraMasInformacionContacteConSu: "Per més informació contacti amb el seu",
    distribuidor: "distribuidor",
    formasDePagoCarta: "Formes de pagament carta",
    formaDePagoCarta: "forma de pagament carta",
    informacionCarta: "Informació carta",
    datosDelNegocio: "Dades del negoci",
    nombreMostrado: "Nom ensenyat",
    telefonoWhatsapp: "Telèfon WhatsApp",
    datosPedidos: "Dades comandes",
    tiempoMedioDePreparacionRecogidaMin: "Tiemps mitjà de preparació recollida (min)",
    tiempoMedioDePreparacionDomicilioMin: "Tiemp mitjà de preparació domicili (min)",
    gastosDeEnvio: "Despeses d'enviament",
    pedidoMinimo: "Comanda mínima",
    interfaz: "Interfície",
    textoEntrega: "Texte entrega",
    textoPresentacion: "Texte presentació",
    textoFormasDePago: "Texte formes de pagament",
    textoHorarios: "Texte horaris",
    datosGuardadosCorrectamente: "Dades guardades correctament",
    materiasPrimasCarta: "Materies primeres carta",
    materiaPrimaCarta: "materia primera carta",
    referenciaMateriasPrimasTpv: "Referència materies primeres Tpv",
    nombreDeLaMateriaPrimaEnElTpv: "Nom de la materia primera en el tpv",
    disponible: "Disponible",
    replicarMateriaPrima: "Replicar materia primera",
    replicarMateriasPrimas: "Replicar materies primeres",
    nombreTpv: "Nom Tpv",
    noDisponible: "No disponible",
    replicarTodasLasMateriasPrimas: "Replicar totes les materies primeres",
    estasSeguroDeReplicarTodasLasMateriasPrimasALosNegociosSeleccionados: 'Estàs segur de replicar totes les matèries primeres als negocis seleccionats?',
    estaAccionNoSePuedeDeshacer: '¡Aquesta acció no es pot desfer!',
    siReplicar: 'Sí, replicar',
    productosCarta: 'Productes carta',
    productoCarta: 'producte carta',
    referenciaProductoTpv: 'Referència producte Tpv',
    nombreDelProductoEnElTpv: 'Nom del producte en el tpv',
    seleccionaCategoria: "Selecciona categoría",
    seleccionaTipo: "Selecciona tipus",
    nIngredientesSinCosto: "Nº ingredients sense cost",
    maximoExtras: "Máxim extres",
    alergenos: "Allèrgens",
    nombreTarifa1: "Nom tarifa 1",
    precioTarifa1: "Preu tarifa 1",
    nombreTarifa2: "Nom tarifa 2",
    precioTarifa2: "Preu tarifa 2",
    nombreTarifa3: "Nom tarifa 3",
    precioTarifa3: "Preu tarifa 3",
    nombreTarifa4: "Nom tarifa 4",
    precioTarifa4: "Preu tarifa 4",
    imagen: "Imatge",
    copiarMateriasPrimas: "Copiar materies primeres",
    basico: "Bàsic",
    buscarNombreDeLaMateriaPrima: "Cercar nom de la matèria primera",
    seleccionaTipoPunto: "Selecciona tipus...",
    bases: "Bases",
    opcionales: "Opcionals",
    extras: "Extres",
    cereales: "Cereals",
    crustaceos: "Crustacis",
    huevos: "Ous",
    pescado: "Peix",
    cacahuetes: "Cacahuets",
    soja: "Soja",
    leche: "Llet",
    frutosDeCascara: "Fruits de closca",
    apio: "Api",
    mostaza: "Mostassa",
    granosDeSesamo: "Grans de sésam",
    dioxidoDeAzufre: "Dióxit de sofre",
    altramuces: "Tramussos",
    moluscos: "Molluscs",
    cartaASecas: "Carta",
    extra: "Extra",
    opcional: "Opcional",
    estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos: 'Aquest procés esborrarà les matèries primeres actuals en les categoríes seleccionades dels tipus escollits',
    aceptarProceso: "Acceptar procés",
    necesitasMarcarAlMenosUnTipoYUnaCategoria: "Necessites marcar al menys un tipus i una categoria",
    materiaPrimaCopiadaCorrectamente: "Materia primera copiada correctament",
    editado: "editat",
    agregada: "afegida",
    relacion: "Relació",
    noPuedeHaberDosMateriasPrimasConElMismoTipo: "No pot haver-hi dues matèries primeres amb el mateix tipusuede haber dos materias primas con el mismo tipo",
    estasSeguroDeBorrarLaMateriaPrima: "Estàs segur d'esborrar la matèria primera?",
    siDeseoBorrarlo: "Sí, desitjo esborrar-lo",
    seleccionaUnaCarta: "Selecciona una carta",
    replicarProductos: "Replicar productes",
    verCarta: "Veure carta",
    verPedido: "Veure comanda",
    verQR: "Veure QR",
    nombreEnTpv: "Nom en tpv",
    cartaYPedido: "Carta y Comanda",
    replicarTodosLosProductos: "Replicar toels productes",
    editarImagen: "Editar imatge",
    esteNegocioNoContieneNingunaCarta: "Aquest negoci no te cap carta",
    estasSeguroDeReplicarTodosLosProductosALosNegociosSeleccionados: 'Estàs segur de replicar tots els productes als negocis seleccionats?',
    sustanciasQue: "Substàncies que",
    componenALosProductos: "composen als productes",
    informacionAcercaDel: "Informació del",
    negocioMinuscula: "negoci",
    actualizarPedidos: "Actualitzar comandes",
    pendienteDeConfirmacion: "Pendent de confirmació",
    confirmados: "Confirmats",
    enPreparacion: "En preparació",
    finalizados: "Finalitzats",
    recogida: "Recollida",
    domicilio: "Domicili",
    noHayPedidosPendientesDeConfirmacion: "No hi han comandes pendents de confirmació",
    noHayPedidosConfirmados: "No hi han comandes confirmades",
    noHayPedidosEnPreparacion: "No hi han comandes en preparació",
    noHayPedidosTerminados: "No hi han comandes acabades",
    siBorrarPedido: "Sí, esborrar comanda",
    estasSeguroDeSuspenderElServicioEnMesas: "Estàs segur de suspendre el servei en taules?",
    siSuspendeElServicioEnMesasNoEntraranMasPedidosEnMesaHastaActivarloDeNuevo: "Si suspen el servei en taules, no entraràn mes comandes fins tornar-lo a activar",
    siSuspenderElServicioEnMesa: "Sí, suspendre el servei en taula",
    estasSeguroDeActivarElServicioEnMesas: " Estàs segur d'activar el servei en taules?",
    siActivaElServicioDeMesasVolveranAEntrarPedidosDeMesa: "Si activa el servei de taules, tornaran a entrar comandes de taules",
    siActivarElServicioEnMesa: "Sí, activar el servei en taula",
    estasSeguroDeSuspenderElServicio: "Estàs segur de suspendre el servei?",
    siSuspendeElServicioNoEntraranMasPedidosHastaActivarloDeNuevo: "Si suspen el servei, no entrarán mes comandes fins que el tornis a activar",
    siSuspenderElServicio: "Sí, suspendre el servei",
    estasSeguroDeActivarElServicio: "Estàs segur d'activar el servei?",
    siActivaElServicioVolveranAEntrarPedidos: "Si activa el servei, tornaràn a entrar comandes",
    siActivarElServicio: "Sí, activar el servei",
    pedidoAceptadoCorrectamente: "Comanda acceptada correctamente",
    pedidoEnPreparacion: "Comanda en preparació",
    pedidoFinalizado: "Comanda finalitzada",
    pedidoArchivado: "Comanda arxivada",
    servicioActualizadoCorrectamente: "Servei actualitzat correctament",
    estasSeguroDeEditarLaObservacion: "Estàs segur d'editar l'observació?",
    siEditarObservacion: "Sí, editar observació",
    mesasActivadas: "TAULES⠀ACTIVADES⠀",
    mesasDesactivadas: "TAULES⠀DESACTIVADES⠀",
    crearNuevoProveedor: "Crear nou proveïdor",
    crearMateriaPrima: "Crear Materia Primera",
    eliminarMateriaPrima: "Eliminar Materia Primera",
    sinCasaAsignada: "Sense casa asignada",
    buscarPorRefONombreDeLaMateriaPrima: "Cercar per Ref. o Nom de la materia primera",
    seleccioneEtiqueta: "Seleccioni etiqueta...",
    unidadesStockMinimo: "Unitats stock mínim",
    partesStockMinimo: "Parts stock mínim",
    anadirProveedor: "Afegir proveïdor",
    amarillo: "groc",
    cajas: "Caixes",
    botellas: "Ampolles",
    barriles: "Bidons",
    palets: "Palets",
    bolsas: "Bosses",
    litros: "Litres",
    rollos: "Rotlles",
    visualizar: "Visualitzar",
    sinCasa: "Sense casa",
    elProveedorEsObligatorio: "El proveïdor és obligatori",
    laFechaEsObligatoria: "La data és obligatoria",
    hayUnaMateriaPrimaSinUnidades: "Hi ha una matèria primera sense unitats",
    hayUnaMateriaPrimaSinPrecio: "Hi ha una matèria primera sense preu",
    guardandoGasto: "Guardant despesa...",
    actualizado: "actualitzat",
    creado: "creat",
    laLongitudDelNombreNoPuedeSerMayorDe: "La llargada del nom no pot ser més gran de ",
    relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar: "Ompli totes les dades marcades amb * avans d'enviar",
    seleccionaProveedor: "Selecciona proveïdor...",
    filtrarPorFecha: "Filtrar per data",
    convertirAlbaranes: "Convertir albarans",
    cancelarConversion: "Cancelar conversió",
    convertir: "Convertir",
    convertirAlbaranEnFactura: "Convertir albarà en factura",
    refFactura: "Ref factura",
    albaranesDeLaFactura: "Albarans de la factura",
    finalizada: "finalitzat",
    conversion: "Conversió",
    error: "Errada",
    estaSeguroDeVerificarEsteGasto: "Està segur de verificar aquesta despesa?",
    siVerficarGasto: "Sí, verificar despesa",
    estasSeguroDeEliminarElGasto: "Estàs segur d'eliminar la despesa?",
    siEliminarGasto: "Sí, eliminar despesa",
    contabilizadoCambiadoCorrectamente: "Contabilitzat canviat correctament",
    gastoEliminadoCorrectamente: "Despesa eliminada correctament",
    hacerInventario: "Fer inventari",
    seleccionarTodas: "Seleccionar Totes",
    inventarioRealizadoCorrectamente: "Inventario realitzat correctament",
    traspaso: "Traspas",
    negocioDeDestino: "Negoci de desti",
    referenciaNecesaria: "Referència necesaria",
    elMovimientoDeAlmacenTieneQueTenerAsignadoUnProductoOProductos: "El movimient de magatzem ha de tindre assignat un producte o productes",
    realizado: "realitzat",
    buscarSinPuntos: "Cercar",
    enviarInventario: "Enviar inventari",
    volverAlAlmacen: "Tornar al magatzem",
    inventarioCompletado: "Inventari complert",
    inventarioNoEncontrado: "Inventari no trovat",
    cargandoInventario: "Carregant inventari",
    importacion: "Importació",
    importar: "Importar",
    tienesQueSeleccionarUnArchivoDeImportacion: "Tens que seleccionar un arxiu d'importació",
    importandoVentasDelNegocio: "Important vendes del negoci...",
    nuevosProductos: "Nous productes",
    seHanCreadoLosSiguientesProductos: "S'han creat els seguents productes",
    importandoMovimientosDeAlmacen: "Important movimients de magatzem...",
    importandoDatos: "Important dades...",
    tienesQueSeleccionarUnArchivoDeImportacion: "Tens que seleccionar un archiu d'importació",
    seleccionaCasa: "Selecciona casa...",
    desgloseDeVentasPorProductos: "Desglòs de vendes per productes",
    noTienesPermisoParaVisualizarEsteInforme: "No tens permis per visualitzar aquest informe",
    historicoVentasPorCliente: "Históric vendes per client",
    buscarPorNombreDelCliente: "Cercar per nom del client",
    importeSinDto: "Import sense Dte.",
    nTickets: "Nº Tickets",
    seleccioneUnClienteValido: "Seleccioni un client vàlid",
    seleccioneUnNegocioParaVerLosTickets: "Seleccioni un negoci per veure els tickets",
    ventasDeCategoriasPorClientes: "Vendes de categoríes per clients",
    desgloseDeVentasDeLaCategoria: "Desglossament de vendes de la categoría",
    verImporteEnCategoriasHijas: "Veure import en categories filles",
    gestionDePedidos: "Gestió de comandes",
    cargandoGastos: "Carregant despeses...",
    tiempoMedioCocina: "Tiemps mitjà cuina",
    nComandas: "Nº Comandas",
    eliminada: "eliminada",
    tiempoMedio: "Temps mitjà",
    noHayComandasEnviadasAlKdsEnEsteRangoDeFechas: "No hi han enviades al kds en aquest rang de dates",
    tiempoMedioProducto: "Temps mitjà producte",
    nProductos: "Nº Productes",
    informePersonalizado: "Informe Personalitzat",
    nombreDelDispositivo: "Nom del dispositiu",
    dispositivo: "Dispositiu",
    registrosHorarios: "Registres horaris",
    marshallEjecutadoCorrectamente: "Marshall executat correctament",
    mes: "Mes",
    seleccionaUnaSemana: "Selecciona una setmana",
    seleccioneUnaFechaValida: "Seleccioni una data vàlida",
    noMayuscula: "NO",
    siMayuscula: "SI",
    editarObservacion: "Editar observació",
    anadirObservacion: "Afegir observació",
    editarHoraInicioYHoraFin: "Editar hora d'inici i hora fi",
    editarHorario: "Editar horari",
    editarHorarioDeTurno: "Editar horari de torn",
    observacion: "Observació",
    turnosOperarios: "Torns operaris",
    compartirEnlaceTurnos: "Compartir enllaç de torns",
    enlaceGeneradoExito:"Enllaç generat correctament",
    enlaceCopiadoAlPortapapeles:"Enllaç copiat al porta-retalls",
    enlaceExternoTurnosTitle: "Enllaç extern per a consulta de torns",
    enlaceExternoTurnosLabel: "A través d'aquest enllaç podeu consultar els torns dels treballadors. Caducarà després de 24 hores.",
    errorComunicacionBackend: "Error de comunicació amb el servidor.",
    enlaceExternoTurnosCaducadoTitle: "L'enllaç ha caducat",
    enlaceExternoTurnosCaducadoLabel: "Per consultar els torns dels operaris, contacteu amb l'administrador del negoci perquè torni a generar un nou enllaç.",
    ventasDeProductosMinusculas: "vendes de productes",
    pedidosGuionPasarelaDePago: "Comandes - Pasarela de Pagament",
    numPedidos: "Num.Comandes",
    costoPorPedido: "Cost per comanda",
    totalComisiones: "Total Comisions",
    totalSinComisiones: "Total sense comisions",
    errorEnLaPeticion: "Errada en la petició",
    rentabilidad: "Rentabilitat",
    buscarPorNombreDelRepartidor: "ercar per nom del repartidor",
    verDesgloseDeTarifas: "Veure Desglossament de tarifes",
    ventasPorMeses: "Vendes per mesos",
    ventasHoras: "Vendes hores",
    tarifasDelProducto: "Tarifes del producte",
    cantidad: "Quantitat",
    fechaDesde: "Data desde",
    fechaHasta: "Data fins",
    seleccionaProcedencia: "Seleccioni procedència...",
    verDesgloseFacturas: "Veure desglossament factures",
    verDesgloseMateriasPrimas: "Veure desglossament de la materia primera",
    seleccionaUnaEtiqueta: "Selecciona una etiqueta",
    buscarPorNombreDeLaMateriaPrima: "Cercar per nom de la materia primera",
    ventasDeMateriasPrimas: "Vendes de materies primeres",
    seleccionaTpv: "Selecciona TPV...",
    deVentas: "de vendes",
    totalComision: "Total comisió",
    totalSinComision: "Total sense comisió",
    desgloseFacturas: "Desglossament factures",
    facturasDelProveedor: "Factures del proveïdor",
    retiradas: "Retirades",
    buscarTicket: "Cercar ticket...",
    baseMayusculas: "BASE",
    numServ: "Num. Serv.",
    ticketMed: "Ticket Mitj.",
    necesitasElegirUnTpvParaPoderVerLosDetallesDeEste: "Necesites escollir un TPV per poder veure-hi els detalls",
    ventasMinusculas: "vendes",
    totales: "Totals",
    noTienesNingunRangoDeFechaCreadoDeseasCrearUnRangoDeFecha: "No tens cap rang de dates creat. Vols crear un rang de dates?",
    siCrearUnRangoHorario: "Sí, crear un rang horari",
    detalleDe: "Detall de ",
    cierresDeCaja: "Tancaments de caja",
    ventasNegocioPorZonaHoraria: "Vendes negoci por zona horaria",
    porZonaHoraria: " per zona horaria",
    detalleDeVentasSegun:"Detall de vendes segons",
    comensalesMinuscula: " comensals",
    desgloseDe: "Desglossament de ",
    ticketsCobrados: "tickets cobrats",
    segunTipoDeIVA: "segons tipus d'IVA",
    facturasEmitidas: "Facturs emeses",
    aClientes: " a clients",
    desgloseDeVentasSegun: "Desglossament de vendes segons ",
    formasDePagoMinusculas: "formes de pagament",
    agenciasMinusculas: "agencies",
    cuentasACredito: "comptes a crédit",
    sumatorioDe: "Sumatori de ",
    impuestos: "impostos",
    porFechas: " por dates",
    cuentasAnuladasMinusculas: "comptes anulades",
    delNegocio: " del negoci",
    cuentasRectificadas: "Comptes rectificades",
    cuentasRectificadasMinusculas: "comptes rectificades",
    retiradasMinusculas: "retirades",
    ventaDeProductosPorNegocio: "Vendes de productes per negoci",
    rankingDe: "Ranking de",
    costeDeProductos: "Cost de products",
    margenDeCostes: "Marge de costos",
    segunVentasPorRangoDeFecha: "segons vendes per rang de dates",
    historicoDeProducto: "Historic de producte",
    rankingAgrupadoDe: "Ranking agrupat de",
    enTodosLosNegocios: "en tots els negocis",
    ventasDeCategoriasPorNegocio: "Vendes de categoríes per negoci",
    agrupacionDe: "Agrupació de",
    ventasDeCategoriasMinusculas: "vendes de categoríes minúscules",
    deProductos: "de productes",
    invitacionesMinusculas: "invitacions",
    ventasPorMateriasPrimas: "Vendes per materies primeres",
    ventasDeMateriasPrimasMinusculas:"vendes de materies primeres",
    comprasDeMateriasPrimas: "compres de materies primeres",
    porRangoDeFecha: "per rang de data",
    comprasAProveedores: "compres a proveïdors",
    comprasAUnProveedor: "compres a un proveïdor",
    porRangoDeFechaEn: "per rang de data en",
    todosLosNegocios: "tots els negocis",
    comprasAgrupadasPorEtiquetas: "compres agrupades per etiquetes",
    comprasAFabricantes: "compres a fabricants",
    comprasAUnFabricante: "compres a un fabricant",
    ranking: "Ranking",
    detallesDe: "Detalls de",
    turnos: "torns",
    ventasPorClientesPlural: "Vendes per clients",
    deVentasPorClientes: "de vendes per clients",
    consultaDeVentasPorCliente: "Consulta de vendes per client",
    historico: "Históric",
    deVentasPorClientes: "de vendes per client",
    numierPedidos: "Numier Comandes",
    informeDePasarelaDePago: "Informe de Pasarella de Pagament",
    desgloseDiarioDeLosPagosATraves: "Desglossament diari dels pagaments a traves",
    pasarelaDePagoStripe: "Pasarella de pagament (Stripe)",
    clicParaMasInformacion: "Clica per mes informació",
    cantidadMinusculas: "quantitat",
    totalMinusculas: "total",
    tarjetaYCheques: "Targeta y Talons",
    seleccionaOperario: "Seleccioni operari...",
    necesitasSeleccionarUnProveedorParaPoderHacerUnPedido: "Necesites seleccionar un proveïdor per poder fer una comanda",
    estePedidoNoEsValido: "Aquesta comanda no és vàlida",
    quieresRestablecerElPedido: "Vols restablir la comanda?",
    siRestablecerPedido: "Sí, restablir comanda",
    datosPersonales: "Dades Personals",
    datosDeAcceso: "Dades d'Acces",
    contrasenaAntigua: "Contrasenya Antiga",
    contrasenaNueva: "Contrasenya Nova",
    confirmarContrasena: "Confirmar Contrasenya",
    quieresDarDeAltaUnUsuario: "Vols donar d'alta un usuari?",
    quieresDarDeBajaUnUsuario: "Vols donar de baixa un usuari?",
    licencias: "Llicències",
    fechaCaducidad: "Data caducidad",
    ilimitado: "ILIMITAT",
    lasContrasenasNoCoinciden: "Les contrasenyes no coincideixen",
    seleccionaUsuario: "Seleccioni usuari...",
    usuario: "Usuari",
    negocios: "Negocis",
    balance: "Balanç",
    teHaParecidoUtilEsteArticulo: "T'ha semblat útil aquest article?",
    graciasPorTuOpinion: "Gracies per la teva opinió",
    asignarTurno: "Asignar torn",
    vacaciones: "Vacances",
    descargarPDF: "Descarregar PDF",
    enviarHorario: "Enviar Horari",
    incidenciasEnElMes: "incidències en el mes",
    diasDeVacacionesEnElMes: "díes de vacances en el mes",
    diasDeVacacionesEnElAno: "díes de vacances en l'any",
    nuevoTurno: "Nou torn",
    clonarTurno: "Clonar torn",
    nombreDelTurno: "Nom del torn",
    diasDeLaSemana: "Díes de la setmana",
    editarTurno: "Editar torn",
    borrarTurno: "Esborrar torn",
    evento: "Esdeveniment",
    nombreEvento: "Nom esdeveniment",
    hayUnaIncidenciaEnEsteTurno: "Hi ha una incidència en aquest torn",
    fechaInicioTurno: "Data d'inici torn",
    fechaFinTurno: "Data fi de torn",
    numHorasTurno: "Nº hores torn",
    fechaInicioTrabajada: "Data d'inici treball",
    fechaFinTrabajada: "Data fi treball",
    numHorasTrabajadas: "Nº hores treballades",
    noIniciado: "No començat",
    noFinalizado: "No acabat",
    fechaInicioVacaciones: "Data inici vacances",
    fechaFinVacaciones: "Data final de vacances",
    turnoHorario: "Torn horari",
    nombreTurno: "Nom torn",
    campoRequerido: "Camp requerit",
    introduzcaLosDiasDeLaSemana: "Introdueixi els dies de la setmana",
    crearTurnoHorarioDeOperario: "Crear torn horari d'operari",
    introduzcaLosOperarios: "Introdueixi els operarios",
    laboral: "Laboral",
    vacacional: "Vacacional",
    seleccionaTurno: "Seleccioni torn...",
    seleccionaLosNegociosALosQueQuiereClonarElTurno: "Seleccioni els negocis als que volclonar el torn",
    seleccionaLaFechaEnLaQueDeseasCopiarLosHorarios: "Seleccioni la data en la que vols copiar els horaris",
    seleccioneUnaSemana:"Seleccioni una setmana",
    lunes: "Dilluns",
    martes: "Dimarts",
    miercoles: "Dimecres",
    jueves: "Dijous",
    viernes: "Divendres",
    sabado: "Dissabte",
    domingo: "Diumenge",
    laFechaSeleccionadaNoEsValida: "La data seleccionada no es vàlida",
    turnoClonadoCorrectamente: "Torn clonat correctament",
    correoEnviadoCorrectamente: "Correu enviat correctament",
    estasSeguroDeBorrarElTurnoSeleccionado: "Estàs segur d'esborrar el torn seleccionat?",
    siBorrarTurno: "Sí, esborrar torn",
    necesitasCrearAlgunTurnoParaPoderCrearCuadrantes: "Necessites crear algún torn per poder crear quadrants",
    estasSeguroDeEditarElTurno: "Estàs segur d'editar el torn?",
    siEditarTurno: "Sí, editar torn",
    hoy: "Avui",
    turno: "Torn",
    turnoBorradoCorrectamente: "Torn esborrat correctament",
    informacion: "Informació",
    elDiaNoCorrespondeConLaConfiguracionDelTurnoElegido: "El dia no correspon amb la configuració del torn escollit",
    turnoCopiadoCorrectamente: "Torn copiat correctament",
    turnoDeOperarioAgregadoCorrectamente: "Torn d'operario agregat correctament",
    turnoDeOperarioEliminadoCorrectamente: "Torn d'operari eliminat correctament",
    turnoDeOperarioEditadoCorrectamente: "Torn d'operario editat correctament",
    tecnicoConsultasTecnicasIncidencias: "Tècnic (Consultes tècniques, Incidències...)",
    comercialActivacionDeProductosInformacionServicios: "Comercial (Activació de productes, Informació, Serveis...)",
    administracionFacturacionReclamaciones: "Administració (Facturació, Reclamacions...)",
    elAsuntoEsObligatorio: "L'assumpte és obligatori",
    elMensajeEsObligatorio: "El missatge és obligatori",
    soporteOnlineEnviadoCorrectamente: "Suport Online enviat correctament",
    todosLosNegociosMayusculas: "Tots els negocis",
    recordarMisDatos: "Recordar les meves dades",
    paraCualquierIncidenciaOMasInformacionPuedePonerseEnContactoConNosotros: "Per qualsevol incidència o més informació es pot posar en contacte amb nosaltres",
    iniciarSesion: "Iniciar sesió",
    haOlvidadoSuContrasena: "Ha oblidat la contrasenya?",
    haHabidoUnErrorAlConectarPruebeDeNuevo: "Hi ha hagut un error al conectar. Torni a provar-ho",
    elEmailNoPuedeEstarEnBlanco: "El email no pot estar en blanc",
    elEmailNoEsValido: "El email no es vàlit",
    laContrasenaNoPuedeEstarEnBlanco: "La contrasenya no pot estar en blanc",
    estaPaginaNoSeEncuentraEnElSistema: "Aquesta pàgina no està en el sistema",
    volverAlInicio: "Tornar a l'inici",
    obtenerContrasena: "Obtindre contrasenya",
    disculpeLasMolestiasEstamosDeMantenimiento: "Disculpi les molèsties, estem de manteniment",
    vuelvaAIntentarloMasTarde: "Torni a intentar-ho més tard",
    acepto: "Accepto",
    categoriasDeClientes: "Categoríes de clients",
    categoriaDeCliente: "categoría de client",
    nombreCategoria: "Nom categoría",
    noSeleccionada: "No seleccionada",
    cobradoMayusculas: "COBRAT",
    envioProgramadoPara: "Envío programat per",
    eliminarPedido: "Eliminar comanda",
    aceptarPedido: "Acceptar comanda",
    pedidoConfirmado: "Comanda confirmada",
    archivarPedido: "Arxivar comanda",
    detallesPedido: "Detalls comanda",
    nota: "Nota",
    precioUd: "Preu Unt",
    gratis: "GRATIS",
    guardarYAceptarPedido: "Guardar i acceptar comanda",
    seleccionaGrupo: "Selecciona grup...",
    todosMayusculas: "TOTS",
    nombreOperario: "Nom operari",
    apellidos: "Cognoms",
    claveAcceso: "Clau accés",
    codigoDeTurnos: "Códi de torns",
    claveAccesoPDA: "Clau d'accés PDA",
    seleccionaIVA: "Selecciona IVA",
    calcularCostoAPartirDeMateriasPrimas: "Calcular cost a partir de materies primeres",
    seleccionaImpresoraDeComandasTPV: "Selecciona impressora de comandes TPV",
    seleccionaImpresoraDeComandasPDA: "Selecciona impressora de comandes PDA",
    buscarMateriaPrima: "Cercar matèria primera",
    nuevaMateriaPrima: "Nova matèria primera",
    ordenarSubproductos: "Ordenar subproductes",
    seleccionaEtiqueta: "Selecciona etiqueta...",
    clonarProducto: "Clonar producte",
    clonarProductoCarta: "Clonar producte",
    buscarSinPuntos: "Cercar",
    noPuedeHaberDosMateriasPrimasConElMismoTipo: 'No hi poden haber dues matèries primeres amb el mateix tipus',
    sinProveedores: "Sense proveïdors",
    agregadas: "afegides",
    modificadas: "modificades",
    materiaPrimaEliminadaCorrectamente: "Matèria primera eliminada correctament",
    asociacion: "asociació",
    materiaPrimaOrdenadaCorrectamente: "Matèria primera ordenada correctament",
    productosCopiadosCorrectamente: "Productes copiats correctament",
    responder: "Respondre",
    cliente: "Client",
    administracion: "Administració",
    soporteTecnico: "Suport tècnic",
    horaInicioMayusculas: "Hora d'Inici",
    horaFinal: "Hora Final",
    personaDeContacto: "Persona de contacte",
    motivoVisita: "Motiu visita",
    servicioBajoMantenimiento: "Servei sota manteniment",
    desplazamiento: "Desplaçament",
    ticketEnviadoCorrectamente: "Ticket enviat correctament",
    precioCompraConDescuento: "Preu de compra amb descompte",
    introduzcaLasPartesDelStockMinimo: "Introdueïx les parts del stock mínim",
    actualizarStockMinimoYOptimo: "Actualitzar stock mínim i óptim",
    subproductoDeVerdad: "Subproducte",
    entregado: "Entregat",
    retirada: "Retirat",
    subtotal: "Subtotal",
    pagosACuenta: "Pagaments a compte",
    horaDeApertura: "Hora d'apertura",
    horaInicio: "Hora d'inici",

    condicionesDeNumierOnline: "Condicions de Numier Online",
    descripcionDelServicio: "Descripcio del Servei",
    terminosIntroduccionParte1: "El servei en el núvol de Numier ofert per NEXODO DIGITAL S.L. (a partir d'ara NEXODO), facilita als seus clients l'accès online a l'informació actualitzada dels seus negocis.",
    terminosIntroduccionParte2: "Per això, les aplicacions de punt de venda de Numier enviaràn a travésd'internet detalls de les vendes realitzades i altre informació interessant pels seus clients.",
    terminosIntroduccionParte3: "L'accès a aquest servei es farà a través de la pàgina web https://www.numier.com/clientes, on podrà consultar l'informació enviada pels seus punts devenda.",
    terminosIntroduccionParte4: "NEXODO reserva el dret de millorar, modificar o anular el servei en qualsevol moment.",
    politicaDePrivacidad: "Política de privacitat",
    privacidadParte1: "1. NEXODO ha fet la següent declaració de privacitat amb l'objectiu de manifestar el seu ferm objectiu de protegir la seva privacitat. NEXODO li prega que llegeixi atentament aquesta politica de privacitat avans de fer servir aquest servei, ya que això implica que NEXODO reculli i processi les seves dades personals d'acord amb aquesta política. NEXODO es reserva el dret a modificar en qualsevol moment la politica de privacitat. En aquest cas NEXODO es compromet a posar-se en contacte amb vosté per informar.li de les modificacions que l'afectin.",
    privacidadParte2: "2. NEXODO respecta les seves opcions de privacitat. En el cas de que ens proporcioni alguna informació es tractarà d'acord amb aquesta política.",
    privacidadParte3: "3. NEXODO li recomana discreció a l'hora de proporcionar informació a operadors o propietaris del lloc. És important que tingui en compte que proporcionar informació personal en llocs d'accés públic, com sales de xat, implica que qualsevol persona amb accés a internet pot disposar de la seva informació. Recomanem que no introdueixi cap informació que no vulgui que es pugui veure en aquestes zones públiques.",
    privacidadParte4: "4. Si decideix registrar-se en NUMIER ONLINE es posible que hagi d'aportar dades personals. Es important que registri correctament l'informació en la data del registre. Si la seva informació personal canvia desprès de fer el registre, tindrà d'actualitzar-la inmediatament. De no fer-ho, es possible que no rebi algun servei o informació de NEXODO.",
    privacidadParte5: "5. NEXODO pot utilitzar la seva informació personal amb la finalitat de fer millores en aquest lloc.",
    privacidadParte6: "6. NEXODO recull aquestes dades amb la finalitat d'obtindre informació per millorar els serveis i productes. I és possible que fem servir la informació que ens proporcioni per enviar-li ofertes per correu electronic o postal que puguis ser del seu interes.",
    privacidadParte7: "7. Per anular la suscripció a aquests correus, s'haurà de posar en contacte amb NEXODO per informar de la seva decisió. D'altre banda NEXODO mantindrà l'informació de l'usuari fins el moment en que la suscripció sigui anulada o fins l'acavament de qualsevol periode necessari descrit en la normativa actual.",
    privacidadParte8: "8. NEXODO no revelarà les seves dades a cap tercer sense el seu consentiment, a menys que pensem de bona fé que la llei ho requereix.",
    privacidadParte9: "9. Te la posibilitat d'anular la totalidad de les dades de la seva suscripció que tenim en la nostra base de dadess. Per aisò haurà de posar-se en contacte amb l'empresa i realitzar la seva solicitud.",
    privacidadParte10: "10. NEXODO ha prés mesures per garantir que lainformació sols estarà disponible per l'usuari que ha introduït la informació en un principi. ",
    privacidadParte11: "11. Sóls es poden accedir a la informació un cop s'hagi introduït la contrasenya.",
    privacidadParte12: "12. Aquest lloc pot tindre enllaços a altres llocs que no estàn associats amb NEXODO. Aquests llocs tenen les seves propies politiques de privacitat de les que NEXODO no s'en fa responsable. L'accés a aquests llocs vinculats es fà sota la seva exclusiva responsabilitat.",
    privacidadParte13: "13. NEXODO garantitza la seguretat de l'informació referent als seus usuaris, exceptuant els casos que es descriuen a continuació:",
    privacidadParte13dos: "- Si NEXODO disposa del seu consentimient.",
    privacidadParte13tres: "- Si s'insta a NEXODO a proporcionar aquesta informació per indicació legal, requerimient judicial u altre procediment jurídic.",
    privacidadParte13cuatro: "- Si la revelació d'aquestes dades és necessaria per protegir els drets i la propietat de NEXODO.",
    privacidadParte13cinco: "- Si la revelació d'informació de les seves dades és necessaria per millorear els serveis i productes del nostres clients, incluit vosté.",
    privacidadParte14: "14. NEXODO garanteix el manteniment adecuat de la seva informació en un servidor segur i encriptat, al que sols hi poden accedir tercers autoritzats. ",

    cartaDigital: "Carta digital",
    horarios: "Horaris",
    zonas: "Zones",
    modificarHorariosDeLaCarta: "Modificar horaris de la carta",
    modificarZonasDeLaCarta: "Modificar zones de la carta",
    diaDeLaSemana: "Dia de la setmana",
    esteNegocioNoTieneCarta: "Aquest negoci no te carta",
    tipoDeEnvio: "Tipus d'enviament",
    nuevoHorario: "Nou horari",
    elCampoDiaDeLaSemanaEsRequerido: "El camp día de la setmana es requerit",
    borrarHorario: "Borrar horari",
    laHoraInicioNoPuedeSerMayorQueLaHoraFin: "L'hora d'inici no pot ser més gran que la hora final",
    noHayHorariosEnEsteNegocio: "No hi han horaris en aquest negoci",
    deseaEliminarEsteHorario: "Vol eliminar aquest horari?",
    siBorrarHorario: "Sí, esborrar horari",
    seleccioneDiaDeLaSemana: "Seleccioni dia de la setmana",
    seleccioneTipoDeEnvio: "Seleccioni tipus d'enviament",

    //NUEVO
    importacionSage: "Importació Sage",
    ejercicio: "Exercici",
    codigoEmpresa: "Codi Empresa",
    asiento: "Assentament",
    cargoAbono: "Carrec Abonament",
    codigoCuenta: "Codi Compte",
    fechaAsiento: "Data Assentament",
    comentario: "Comentari",
    importeAsiento: "Import Assentament",
    numeroPeriodo: "Número Periode",
    delegacion: "Delegació",
    canal: "Canal",
    ejercicioFactura: "Exercici Factura",
    serie: "Sèrie",
    factura: "Factura",
    suFacturaNo: "La seva Factura No",
    fechaFactura: "Data Factura",
    importeFactura: "Import Factura",
    tipoFactura: "Tipus Factura",
    codigoCuentaFactura: "Códi Compte Factura",
    codigoRetencion: "Códi Retenció",
    baseRetencion: "Base Retenció",
    porRetencion: "Per Retenció",
    importeRetención: "Import Retenció",
    baselva1: "Base lva 1",
    porlva1: "Por lva 1",
    cuotaIva1: "Quota IVA 1",
    porRecargoEquivalencia1: "Per Recarrec Equivalencia 1",
    recargoEquivalencia1: "Recarrec Equivalencia 1",
    codigoTransaccion1: "Códi Transacció 1",
    descargarComoTxt: "Descarregar com .txt",

    noHayAsientosContablesEnEsteTpvEnEsteRangoDeFecha: "No hi han assentaments contables en aquest tpv amb aquest rang de dates",
    cargandoAsientosContables: "Carregant assentaments contables",
    fechaDeAperturaDeCaja: "Data d'apertura de caixa",
    fechaDeCierreDeCaja: "Data de tancament de caixa",
    descargarVentas: "Descarregar vendes",
    descargarGastos: "Descarregar despeses",
    noHasCerradoEstaCaja: "No has tancat aquesta caixa",
    numeroDeCierres: "Número de tancaments",
    introduzcaElUltimoNumeroDeAsientoContableQueTieneEnSAGE: "Introdueix l'ultim assentament contable que té a SAGE",
    porFavorRelleneElAsientoContable: "Si us plau, ompli l'assentament contable",
    descargar: "Descarregar",
    elAsientoContableDebeSerUnNumero: "L'assentament contable ha d'esser un número",
    elAsientoContableNoPuedeSerMayorA10Digitos: "L'assentament contable no pot tindre més de 10 dígits",
    TengaEnCuentaQueUtilizaremosLosSiguientesNumerosAEsteParaCompletarLosDatos: "Tingui en comte que farem servir els seguents numeros a aquest per completar les dades",
    noExistenVentasEsteDia: "No existeixen vendes aquest día",
    noExistenGastosEsteDia: "No existeixen despeses aquest día",
    enSage: "a SAGE",
    proyecto: "Projecte",
    codigoEmpresaHelp: "Recordi que la dada empresa es comparteix entre tots els negocis de la mateixa empresa",
    cuentasDelTpvSeleccionado: "Comptes del TPV seleccionat",
    nuevaCuenta: "Nou compte",
    nombreDeCuenta: "Nom del compte",
    codigoCuentaMinuscula: "Códi compte",
    tipoDeCuenta: "Tipus de compte",
    noHayCuentasCreadasConElTpvSeleccionado: "No hi han comptes creades amb el TPV seleccionat",
    crearNuevaCuenta: "Crear nou compte",
    codigoDeLaCuenta: "Códi del compte",
    codigoDeLaSubcuenta: "Códi del subcompte",
    configuracionCuentasIva: "Configuració comptes IVA",
    configuracionCuentasEspeciales: "Configuració comptes especials",
    cuenta: "Compte",
    subcuenta: "Subcompte",
    editarCuenta: "Editar compte",
    tipo: "Tipus",
    sage200: "SAGE 200",
    losCamposNombreCodigoDeCuentaYCodigoDeSubcuentaDebenEstarRellenos: "Els camps nom, codi de compte i codi de subcompte han d'estar farcits",
    estaSeguroDeQueDeseaEliminarEstaCuenta: "Esteu segur que voleu suprimir aquest compte?",
    siBorrarCuenta: "Sí, esborrar compte",
    cuentaEditadaCorrectamente: "Compte editada correctament",
    cuentaCreadaCorrectamente: "S'ha creat el compte correctament",
    configuracionSAGE: "Configuració SAGE",
    sinCuentaAsociada: "Sense compte associat",
    loSientoSuNegocioNoTieneContratadoSAGE: "Ho sentim, el seu negoci no té contractat SAGE",
    paraMasInformacionContacteConComerciales: "Per a més informació contacti amb comercials",

    // ----
    laLongitudMaximaDeLasSubCuentas: "La longitud máxima de la sub cuenta tiene que ser de 12 caracteres",
    codigo: "Código",
    crearNuevoCodigoCuenta: "Crear nuevo código cuenta",
    editarNuevoCodigoCuenta: "Editar nuevo código cuenta",
    seleccioneUnaFormaDePagoParaElGasto: "Seleccione una forma de pago para el gasto",
    hasSeleccionadoAlbaranesConDiferentesFormasDePagoPorFavorSeleccioneUna: "Has seleccionado albaranes con diferentes formas de pago, por favor seleccione una",
    seleccioneUnaFormaDePago: "Seleccione una forma de pago",
    zonasActualizadasCorrectamente: "Zonas actualizadas correctamente",
    zonaCreadaCorrectamente: "Zona creada correctamente",
    zonaEditadaCorrectamente: "Zona editada correctamente",
    guardarCambios: "Guardar cambios",
    laZonaNoPuedeTenerElNombreEnBlanco: "La zona no puede tener el nombre en blanco",
    zonasDeReparto: "Zonas de reparto",
    editarZona: "Editar zona",
    color: "Color",
    costeDeReparto: "Coste de reparto",
    pedidoMinimo: "Pedido mínimo",
    crearNuevaZona: "Crear nueva zona",
    estasSeguroDeQueQuieresEliminarLaZona: "¿Estás seguro de que quieres eliminar la zona?",
    estaZonaDejaraDeEstarDisponibleInmediatamenteYNoSePodranHacerPedidos: "Esta zona dejará de estar disponible inmediatamente y no se harán pedidos desde la misma",
    siEliminarZona: "Sí, eliminar zona",
    zonaEliminadaCorrectamente: "Zona eliminada correctamente",
    ventasExportadas: "Ventas exportadas",
    gastosExportados: "Gastos exportados",
    todosLosCierresDeEsteDiaHanSidoExportados: "Todos los cierres de este día han sido exportados",
    faltanVentasPorExportarEsteDia: "Faltan ventas por exportar este día",
    todosLosGastosDeEsteDiaHanSidoExportados: "Todos los gastos de este día han sido exportados",
    faltanGastosPorExportarEsteDia: "Faltan gastos por exportar este día",
    /*this.$i18n.t("productos"))*/

    /*"$i18n.t('editar')*/

    //10-02-2021
    otros:'Otros',
    restriccionHorarios:'Restricción Horarios',
    restriccionHorariosDesc: "Restringir algunas franjas horarias(cerrado, lleno, no reparto...)",
    borrar: 'Borrar',
    restriccion: "Restricción", 
    nMaximoPedidos: "Nº Máximo de pedidos",
    cerrarFranja: "Cerrar franja",
    limitePedidos: "Límite Nº Pedidos",
    loSentimosSuNegocioNoTieneContratadoEsteModulo: "Lo sentimos, su negocio no tiene contratado este módulo",
    numeroPedidosPermitidos: "Número de pedidos permitidos",
    estaSeguroDeQueDeseaEliminarEstaRestriccion: "¿Está seguro de que desea eliminar esta restricción?",
    siBorrarRestriccion: "Sí, borrar restricción",
    loSentimosParaAccederAEsteModuloNecesitaActivarLaConfiguracion: "Lo sentimos, para acceder a este módulo necesita activar la configuración",
    costeSinIVA: "Coste sin IVA",

    //11.3.2021
    importeIVA: "Importe IVA",

    //17.3.2021
    pasarAPreparacion: "Pasar a preparación",
    pasarAPreparados: "Pasar a preparados",
    pasarAEnReparto: "Pasar a en reparto",
    finalizarPedido: "Finalizar pedido",
    //Tener en cuidado con los espacios, ya que son los espacios Braille
    domicilioActivado: "‏‏‎DOMICILIO⠀ACTIVADO",
    domicilioDesactivado: "DOMICILIO⠀DESACTIVADO",
    recogerActivado: "RECOGER⠀ACTIVADO",
    recogerDesactivado: "RECOGER⠀DESACTIVADO",

    //
    conDetalles: "con detalles",
    zonasRepartoActivadas: 'ACTIVADAS⠀',
    zonasRepartoDesactivadas: 'DESACTIVADAS⠀',
    siEliminarCategoria: "Sí, eliminar categoría",
    confirmaEliminarCategoria: "¿Está seguro de que quiere eliminar esta categoría?",
    pedidoPreparado: "Pedido preparado",
    configuracionParaLaImportacionExportacionDeDatosDeSage: "Configuración para la importación/exportación de datos de Sage",
    enEstaPantallaSeConfiguranLosCodigosDeLasCuentas: "En esta pantalla se configuran los códigos de las cuentas",
    formadosPor3Digitos: 'formados por 3 dígitos',
    estosSonNecesariosParaConfigurarLasCuentasContables: "Estos son necesarios para configurar las cuentas contables",
    alEditarUnCodigoRelacionadoConUnaCuentaContableYaExistente: "Al editar un código relacionado con una cuenta contable ya existente",
    todoCambioQueSeProduzcaSobreEsteAfectaraTambienALaPropiaCuenta: "todo cambio que se produzca sobre este afectará también a la propia cuenta",
    aContinuacionSeListaranLasCuentasDeTipo: "A continuación se listarán las cuentas de tipo",
    gastoMinuscula: "gasto",
    paraQue: "para que",
    asocieMinuscula: "asocie",
    ventaMinuscula: "venta",
    unaParaSuPosterior: "una para su posterior",
    relacionEnSage: "relación en SAGE",
    seleccioneUnaCuenta: "Seleccione una cuenta",
    aDomicilio: "A domicilio",
    aRecoger: "A recoger",
    tipoDeZona: "Tipo de zona",
    seleccioneUnTipo: "Seleccione un tipo",
    kilometrosDelArea: "Kms del área",
    codigoEmpleado: "Codigo empleado",
    exportarReservas: "Exportar reservas",
    importacionSinqro: "Importación Sinqro",
    configuracionParaLaImportacionDeDatosDeSinqro: "Configuración para la importación de datos de Sinqro",
    pasarelaDePago: "Pasarela de pago",
    importeSinDescuento: "Importe sin descuento",
    desactivarZona: "Desactivar zona",
    activa: "ACTIVA",
    inactiva: "INACTIVA",
    exportarPdfConMateriasPrimasAsociadas: "Exportar PDF con materias primas asociadas",
    exportarExcelConMateriasPrimasAsociadas: "Exportar Excel con materias primas asociadas",

    //Pedidos archivados 18/05/21
    informePedidosDetalle:"Desglose de pedidos",
    informePedidos:"Informe de pedidos",
    tipoPago:"Forma de pago",
    tipoPedido:"Tipo de pedido",
    domicilio:"Envio a domicilio",
    recoger:"Recogida en local",
    pagoLocal:"Pago en local",
    otro:"Otro",

    //25/05/2021
    configuracionTurnos: "Configuración turnos",

    //2021/05/20
    estasSeguroDeImportarTusProductosASinqro: "¿Desea importar sus productos a Sinqro?",
    esteProcesoPuedeTardarVariosMinutos: "Este proceso puede tardar varios minutos.",
    siImportarConSinqro: "Sí, importar a Sinqro",
    estasSeguroDeDarDeBajaElProducto: "¿Desea dar de baja el producto?",
    podraDarloDeAltaEnUnFuturo: "Podrá darlo de alta en un futuro",
    siDarDeBaja: "Sí, dar de baja",
    estasSeguroDeDarDeAltaElProducto: "¿Desea dar de alta el producto?",
    podraDarloDeBajaEnUnFuturo: "Podrá darlo de baja en un futuro.",
    siDarDeAlta: "Sí, dar de alta",
    laImportacionTardara: "Importando... este proceso puede tardar varios minutos",
    importacionFinalizada: "Importación completada con exito",
    completo: "Completado",
    vale: "Vale",
    importarSinqro: "Importar Sinqro",
    importandoProductos: "La importación se está llevando a cabo en estos momentos...",
    generandoCarta: "Este es el último paso... Estamos generando su carta.",
    procesoFin: "El proceso se ha completado con éxito",
    procesoCompletado: "Proceso completado",
    yaFaltaPoco: "Ya falta poco...",
    estamosEnEllo: "Estamos trabajando en la importacion. Por favor, no recargue el navegador. " ,
    finProgres: "El progreso terminó con exito.",
    textoInfo:"Esta columna muestra el precio de compra con descuento (el cual se calcula a partir del precio sin IVA)",
    correosEnviados: "Correus enviats",
    correosEnviadosCorrectamente: "Els correus s'han enviat correctament.",
    errorAlEnviar: "Error en enviar",
    noSePudieronEnviarTodosLosCorreos: "No s'han pogut enviar tots els correus:",
    errorInesperadoEnvioCorreos: "S'ha produït un error inesperat. Si us plau, torni-ho a intentar més tard.",


    //07/06/2021
    valorRecuento: "Valor Recuento",
    
    //08/06/2021
    obligatorioEmail: "Obligatorio rellenar email",
    datosCliente : "Datos cliente",

    //11/06/2021
    recuerdeQueElHacerCobrosAvanzadosPuedeGenerarPequenosDescuadres:"Recuerde que el hacer cobros avanzados puede generar pequeños descuadres",
    yQue: "y que",
    losDescuentosDeLasVentasEstanAlCeroPorcientoDeIva:"los descuentos de las ventas estan al 0% de IVA",

    //16/06/2021
    totalValoresNegativos: "Total Valores Negativos",
    solamenteSeTieneEnCuentaValoresPositivos: "Solamente se tiene en cuenta valores positivos",
    totalValoresDiferencia: "Total Valores Diferencia",
    totalValoresDiferenciaDto: "Total Valores Diferecia Dto.",
    valorDiferencia: "Valor diferencia",
    valorDifereciaDto: "Valor diferencia dto.",
    precioDto: "Precio Dto.",

    //24/06/2021
    exportarMateriasPrimasAsociadasAEsteProducto: "Exportar materias primas asociadas a este producto",
    sinIVA: "Sin IVA",

    
    //MENÚS
    menus: "Menús",
    descripcionMenus: "Grupo de productos que se venden de forma conjunta",
    numeroDePlatos: "Número de platos que el cliente podrá elegir por cada plato:",
    platosTip1: "En esta pantalla se pueden crear los distintos platos que",
    platosTip2: "componen el menú para su posterior asignación con los productos.",
    productosPlatosTip: "En esta pantalla se pueden relacionar platos y productos para su posterior visualización en la carta.",
    plato: "Plato",
    platos: "Platos",
    primerPlato: "Primer plato",
    segundoPlato: "Segundo plato",
    tercerPlato: "Tercer plato",
    cuartoPlato: "Cuarto plato",
    quintoPlato: "Quinto plato",
    sextoPlato: "Sexto plato",
    seleccionaUnPlato: "Selecciona un plato",
    noPuedeDejarEnBlancoElNombreDeUnPlato: "No puede dejar en blanco el nombre de un plato",
    estaSeguroDeQueQuiereBorrarEstePlato: "¿Está seguro de que quiere borrar este plato?",
    seBorraranTodasLasAsociacionesDeProductosConElMismo: "Se borrarán todas las asociaciones de productos con el mismo",
    siEstoySeguro: "Sí, estoy seguro",
    estaSeguroDeQueQuiereDesvincularEsteProductoDelPlatoSeleccionado: "¿Está seguro de que quiere desvincular este producto del plato seleccionado?",
    dejaraDeFormarParteDelMenuDeFormaInstantanea: "Dejará de formar parte del menú de forma instantánea",
    noMostrarSuelto: "No mostrar suelto (sólo disponible en menús)",
    //29/07/2021
    totalPedidosDevueltos : "Nº de devoluciones",
    totalImportesDevueltos : "Total importe devuelto",

    //06/08/2021
    NoMostrarRecargasSaldo: "No mostrar recargas de saldo",
    //10/08/2021
    noMostrarDescuento: "No mostrar descuentos",
    //17/08/2021
    operarioApertura: "Operario apertura",
    aperturasPorOperarios: "Cuentas abiertas por operario",
    aperturasPorOperariosMinuscula: "cuentas abiertas por operario",
    aperturasOperarios : "Cuentas abiertas",
    productosPorAperturaDe: "Productos por apertura de",
    productosPorApertura:"Productos por apertura",
    facturasEmitidasMinuscula:"facturas emitidas",
    noMostrarDescuento: "No mostrar descuentos",

    //17/08/2021
    rangosDeMesas: "Rangos de mesas",
    agrupacionesDeMesasParaConsultarVentas: "Agrupaciones de mesas para consultar ventas",
    verUnInformeDeRangosDeMesas: "Ver informe de rangos de mesas",
    nuevoRangoMesa: "Nuevo rango mesa",
    mesaInicial: "Mesa inicial",
    mesaFinal: "Mesa final",
    noHayRangosDeMesasEnEsteTpv: "No hay rangos de mesas en este TPV",
    nombreRangoDeMesas: "Nombre rango de mesas",
    borrarRangoMesas: "Borrar rango de mesas",
    deseaEliminarEsteRangoDeMesas: "¿Desea eliminar este rango de mesas?",
    siBorrarEsteRangoDeMesas: "Sí, borrar este rango de mesas",
    ventasPorRangoDeMesas: "Ventas por rango de mesas",
    porRangoDeMesas: " por rango de mesas",
    numeroDeOperaciones: "Número de operaciones",
    precioMedioPorOperacion: "Precio medio por operación",
    propuestoParaCierre: "Propuesto para cierre",
    esteTicketHaSidoPropuestoParaSuCierreComaEstaUstedDeAcuerdo: "Este ticket ha sido propuesto para su cierre, ¿está usted de acuerdo?",
    siCerrarTicket: "Sí, cerrar ticket",
    propuestaDeCierreDeTicket: "Propuesta de cierre de ticket",
    noEstoyDeAcuerdo: "No estoy de acuerdo",
    ultimaRespuestaDelEquipoTecnico: "Última respuesta del equipo técnico",
    escribaAquiSuRespuesta: "Escriba aquí su respuesta",
    enviarRespuesta: "Enviar Respuesta",
    tienesTicketsPendientesDeCerrar: "Tienes tickets pendientes de cerrar",

    //26/08/2021
    exportarExcelDeTodosLosTickets: "Exportar Excel de todos los tickets",
    soloPuedesSacarInformesDeUnMesComoMaximo: "Solo puedes sacar informes de un mes como máximo",
    loSentimos: "Lo sentimos",
    noTienesNingunRangoDeMesasCreadoDeseasCrearUnRangoDeMesas: "No tienes ningun rango de mesas creado. ¿Deseas crear un rango de mesas?",
    siCrearUnRangoMesas: "Sí, crear un rango mesas",
    
    // 07/08/2021
    usuarioSinAcceso: "Su usuario no tiene acceso a este modulo",

    //08/09/21
    pedidosHoras: "Pedidos por horas",
    graficaPedidosHoras: "Gráfica que muestra el número de pedidos agrupado por tramo horario en el dia de hoy",

    //20/09/21
    personalizacionCarta: "Personalizacion de la Carta Online",
    personalizacionCarta: "Personaliza tu carta ",
    personalizacion: "Personalización",
    conLasOpcionesQueTeOfrecemos: "con las opciones que te ofrecemos",
    opcionesConfiguracion: "Opciones de configuración",
    vistaPrevia: "Vista previa",
    imagenCargando: "Imagen de carga",

    //21/09/21
    diagnosis: "Diagnosis",
    diagnosticoProductos : "Diagnóstico de productos",
    comprobacionProducts: "Comprobación de productos", 
    diagnosticarProductos: "Diagnosticar productos",
    productosSinRelacionEnElTpv : "¡Todo correcto!",
    pulseElBoton:"Pulse el botón deseado",
    paraRealizarDiagnosis : "para realizar la diagnosis",
    productoRelacionadoConTpv : "Relacionado en el TPV con",
    noTieneRelacion:"No tiene relacion",
    hayProductosSinRelacion:"Hay productos que no estan relacionados en el TPV",
    
    //20/09/21
    destacadosTitulo: "Titulo destacado",
    nuevoTitulo: "Nuevo titulo",
    tituloActual: "Titulo actual",

    //22/09/21
    textos: "Textos",

    //21/09/21
    facturas: "Facturas",
    facturasMinusculas: "facturas",
    facturacionGeneral: "Facturación general",
    deTodasLasSeries: " de todas las series",

    //29/09/21
    permisoBusinessGestion: "Lo sentimos. No tienes permiso para utilizar esta herramienta en el negocio actual",
    permisoUsuarioGestion: "Lo sentimos. Este negocio no cuenta con este módulo activado.",
    traduccion: "Traducción",
    traduccionDe: "Traducción de",
    idioma: "Idioma",
    losDescuentosDeLasVentasEstanAlCeroDeIva: "Los descuentos de las ventas están al 0% de iva",
    recuerdeQueAlRealizarCobrosAvanzadosLosComensalesSeAsignaranALaFormaDePagoEfectivo: "Recuerde que al realizar cobros avanzados los comensales se asignaran a la forma de pago efectivo",
    mapasYZonas: "Mapas y zonas",
    idiomas: "Idiomas",
    permisoControlIdiomas: "Lo sentimos, este negocio no cuenta con el control de idiomas activado.",
    idiomasCartaTip1: "Para activar o desactivar un idioma puedes hacer clic en los interruptores.",
    idiomasCartaTip2: "Para ordenar los idiomas en la carta, puedes utilizar el campo orden.",
    idiomasCartaTip3: "Los idiomas con un orden menor aparecerán primero.",
    excluirPrecioMedioMenu: "Excluir del precio medio los productos vendidos en menús",

    //19/06/2023
    conIvaDesglosado: "amb IVA desglossat",

    //10/01/24
    tolTipLogo: "Afegeix el logotip del teu restaurant perquè aparegui a la pantalla d'inici i al teu codi QR. La mida recomanada és de 90 x 90 px.",
    tolTipFondo: "Afegeix una foto d'alta qualitat perquè aparegui com a portada al teu menú QR. La mida recomanada és de 1280 x 1024 px.",
    tolTipImagenProducto: "Afegeix una imatge d'alta qualitat per mostrar visualment i atractiu el teu producte. Per als productes al menú, crea'n un de nou amb una resolució ideal de 500 x 500 píxels o 12 cm x 12 cm.",
    tolTipNombreMostrado: "Escriu aquí el nom que vols que es mostri pel teu negoci.",
    tolTipEmail: "Facilita un correu electrònic de contacte pels teus clients.",
    tolTipTelefono: "Facilita un telèfon de contacte.",
    tolTipDescripcion: "Descriu breument el teu restaurant: el concepte i l'experiència que ofereixes.",
    tolTipDireccion: "Facilita l'adreça del restaurant a la qual pertany aquesta carta.",
    tolTipPresentacion: "Escriu una crida a l'acció adequada perquè els teus clients vulguin obrir la teva targeta a la pantalla d'inici.",
    tolTipHorario: "Presenta el teu horari o comparteix informació extra (vacances, fora de servei...).",
    tolTipMostrarCategoriaDeBaja: "Si marques la casella, es mostraran les categories que has donat de baixa, però no apareixeran a la teva carta.",
    tolTipMostrarProductoDeBaja: "Si marques la casella, es mostraran els productes que has donat de baixa, però no apareixeran a la teva carta.",
    tolTipTraducirCategoria: "Tradueix al idioma que vulguis el títol de les categories.",
    tolTipConvertirCategoriaPadre: "Converteix en categoria pare.",
    tolTipOrdenCategorias: "Si vols que aquesta categoria aparegui com la primera, el número hauria de ser '1', i així consecutivament segons l'ordre.",
    tolTipBajaCategoria: "En activar aquesta opció, la categoria seleccionada deixarà de mostrar-se al teu menú digital quan els clients hi accedeixin. La desactivació d'una categoria implica que tots els productes que hagis inclòs sota aquella categoria específica també deixaran de ser visibles pels teus clients.",
    tolTipVerQr: "Accedeix i descarrega el codi QR de la teva carta.",
    tolTipDisponibleProducto: "Marca la disponibilitat del producte: Indica si un producte està disponible o no a la teva carta.",
    tolTipIdiomaProducto: "Selecciona l'idioma en què també vols que es presenti el producte.",
    tolTipOrdenProducto: "Selecciona l'ordre en què vols que aparegui el producte dins de la categoria seleccionada.",
    tolTipProductoDestacado: "Si seleccionas aquesta opció, el producte apareixerà en una secció destacada a l'inici de la carta. Destaca productes especials o promocions.",
    tolTipBaja: "Aquest producte no es mostrarà a la teva carta (si està activat).",
    tolTipDisponible: "Activa el botó si el producte està disponible per a la venda. Desactiva'l si el producte està 'Fora d'estoc' (quan no hi ha existències).",
    tolTipImagenCarga: "Imatge que es mostrarà durant els breus segons en què la teva carta es carrega.",
    tolTipTituloDestacado: "Aquí pots definir el text que nomenarà la secció de productes destacats. Exemple: 'Suggeriments del Xef', 'Els nostres Top Ventas' o 'No et Pots Perdre'.",
    tolTipIdiomaMateriaPrima: "Tria l'idioma en què també vols que es presenti la primera matèria",
    guiaUsuario: "Guia d'usuari",

    //12/03/24
    basesFree: "Bases addicionals gratuïtes",
    extrasFree: "Bases / Extres gratuïts",
    tooltipBaseExtra: "Si la base està activada, no suma extra gratuïtament. Si l'extra està activat, no comptarà com a gratuït en afegir-se.",

    exportar: "Exportar",
    codigoBarras: "Codi de barres",

    //WALLET
    passbooks: "Passbooks",
    sharePassbooks: "Compartir wallets",
    copyToClipboard: "Copiar al porta-retalls",
    shareViaEmail: "Enviar per e-mail",
    shareViaWhatsapp: "Enviar per WhatsApp",
    copied: "Copiat al porta-retalls",
    selectBusinessForWallet: "Tria el negoci per al qual vols enviar les Wallets",
    sendMethod: "Mètode d’enviament",
    share: "Enviar",
    sendAndSaveButton: "Sí, enviar i guardar",
    sendAndNoSaveButton: "No, enviar i no guardar",
    titleSaveInfoModalText: "La informació del client ha canviat. Voleu guardar aquesta informació?",
    verifyNumberText: "Verifiqueu el telèfon",
    verifyEmailText: "Verifiqueu el correu electrònic",
    selectOption: "Seleccioneu una opció",
    clipboardCopied: "Copiat al porta-retalls",
    clipboardFailedToCopy: "L’API del porta-retalls no està disponible en aquest navegador.",
    enviarWallet: "Enviar Wallet",
    confirmacionEnvioWallet: "Confirmació d'Enviament de Wallet",
    confirmacionTextoEnviarWallet: "Està segur que vol enviar la wallet a tots els clients?",
    mensajeConfirmacion: "Aquesta acció no es pot desfer i només s'enviarà als clients que tinguin el correu electrònic afegit i disposin d'un Codi de barres.",
    enviar: "Enviar",
    noHayCorreosElectronicos: "No hi ha correus electrònics.",
    ningunClienteConCorreoElectronico: "No s'ha trobat cap client amb un correu electrònic configurat.",
    clientHasNoBarcode: "El client no té un codi de barres establert.",

    exportarCarta: "Exportar carta",
    exportarSimplifiedExcel: "Exportar com a Excel (Sense capçaleres)",
    //18/10/24
    listadoTicketRepartidor: "Tickets per repartidor",

    //GESTIÓN DE IMPUESTOS
    taxes: "Impostos",
    tax: "Impost",
    gestionImpuestos: "Gestió d'Impostos",
    administracionTiposTasas: "Administració",
    administracionTiposTasasImpositivas: " de tipus i taxes impositives",
    agregarImpuesto: "Afegir Impost",
    taxRate: "Impost Aplicat",
    taxDescription: "Descripció",
    taxType: "Tipus d'Impost",
    taxBoldType: "impostos",
    impuestoAplicadoEsCero: "L'Impost Aplicat no pot ser menor de ",
    impuestoYaCreado: "Aquest impost ja existeix i no es pot crear de nou",

    //IMPORTAR CLIENTES 
    previewClientData: "Previsualització",
    editarCliente: "Editar Client",
    importarData: "Importar Dades",
    importandoDatos: "Important Dades",
    preview: "Previsualitzar",
    importacionRealizada: "Importació realitzada",
    datosImportados: "Les dades s'han importat correctament",
    confirmarImportacion: "Confirmar importació",
    seguroContinuarImportacion: "Estàs segur que vols continuar? Aquesta acció és irreversible",

    //18/11/24-Save-Logo
    inserteImagen: "Inserir Imatge",
    seleccioneArchivoImagen: "Selecciona un arxiu d'imatge",
    archivoDemasiadoGrande: "O arquivo é grande demais. La mida màxima permesa és de 5MB.",
    dimensionesExcedenLimite: "Les dimensions de la imatge excedeixen el límit permès (2000x2000px).",
    mensajeconfirmacion: "Estàs a punt de reemplaçar la imatge existent. Vols desar-la?",
    botonGuardar: "Desar",
    botonCancelar: "Cancelar",
    Guardado: "Desat",
    guardarOvisualizarLogo: "Veure o desar el logo",
    seleccionLogo: "Feu clic per seleccionar un logo",
    volver: "Tornar",
    noHayImagen: "No hi ha cap imatge guardada.",
    informacion: "Informació: ",
    tamaño: "Midas: ",
    dimensiones: "Dimensions: ",
    restriccionesLogo: "Restriccions del logo:",
    tamañoMaximo: "Mida màxima: ",
    dimensionesMaximas: "Dimensions màximes: ",

    //13/12/24
    //ProductosNoRelacionados.NEW
    mensajeAviso: "Està segur que vol generar automàticament els PLU? Aquest procés generarà un codi per a cada producte i tarifa no configurats, i es desarà automàticament.",
    mensajeAvisoSubProducto: "Està segur que vol generar automàticament els PLU? Aquest procés generarà un codi per a cada matèria primera no configurada i es desarà automàticament.",    
    aviso: "Advertència!",
    generarPlu: "Generar Automàticament PLUs",
    botonAceptar: "Acceptar",
    PLUsGenerados: "PLU generats correctament!",
    errorGenerandoPLUs: "Error en generar els PLUs",

    //ListadomateriaPrima-Proveedor.
    //14/01/25
    verListado: "Llistat de matèries primeres",
    listadoMateriaPrimaProveedor: "Llistat de matèria primera proveïdor",
    noTiene: "No té ",
    esteProveedor: " aquest proveïdor",
    proveedor: "Nom del Proveïdor:   ",
    precioAcordado: "Preu acordat amb el proveïdor",
    porcentajeAcordado: "Percentatge acordat",
    FiltrarPorEtiqueta: "Filtrar per etiqueta:",
    precioAcordadoGuardadoCorrectamente: "Preu acordat guardat correctament!",
    fijarprecio: "Fixar preu ",
    preciofijado: "(Fixar el preu de la matèria primera)",
    mensajePrecioFijado: "El preu de la matèria primera és de  ",
    explicacionFijarPrecio: "En activar-ho, el preu de la matèria primera i el percentatge de descompte quedaran fixats. En fer una nova despesa, ni el preu ni el descompte es veuran modificats.",
    porcentajeAcordado: "Percentatge d'avís",
    porcentajeAcoradoGuardado: "Percentatge acordat. Guardat correctament!",
    SubproductoIncrementado: "Matèria primera incrementada",
    LosSubproductosSeHanIncrementado : "No s'ha pogut verificar la despesa, ja que s'ha detectat un increment en el preu de les següents matèries primeres respecte al percentatge acordat amb el proveïdor",
    errorverificar: "Error en verificar",
    MateriaPrimasIncremento:"S'ha registrat un augment del 5% en les següents matèries primeres: ",
    ConfirmacionGuardar: "Voleu guardar?",
    Elsubproducto: " La matèria primera ",
    MensajeErrorVerificarTodo: "No es pot verificar totes les despeses ja que les següents despeses presenten un increment en el preu de la matèria primera respecte al percentatge acordast amb el proveïdor",
    explicacionPorcentajeAcordado: "Aquest és el percentatge acordat per al proveïdor, per al control del preu de les matèries primeres a l'hora de realitzar una despesa.",
    //21/01/2025
    nosmudamos: "Ens traslladem!",
    noscambiamosaselfi: "El teu negoci ha fet un gran pas: ara formem part de la família Selfibar. A partir d'ara, totes les configuracions i gestions les podràs realitzar directament a Selfibar",
    irASelfibar: "Anar a Selfibar",
    barcodeUnico: "Codi de barres únic",
    barcodeNecesarioSeActualizara: "El codi de barres és necessari per a aquesta acció i s'actualitzarà per a aquest client en enviar o copiar al porta-retalls.",
    generarBusinessHash: "Generar URL per a operaris",
    enlaceFicharTurnosOperario: "Accés per fitxar i consultar torns",
    enlaceFicharTurnosOperarioDescripcion: "Els treballadors del negoci podran iniciar sessió amb les mateixes credencials que al TPV per registrar l'inici i la fi del seu torn, així com consultar els últims 14 torns realitzats juntament amb els seus temps.",


        // //KIOSKOS
        // kioskos: "Kioskos",
        // stockBreak: "Rotura de stock",

};


// WEBPACK FOOTER //
// ./src/language/catalan.js